    /* Extracted from sections/cart-popup.liquid (Sept 2026 performance work) and loaded with
       defer. Inline, the ready() callback waited for DOMContentLoaded; as a deferred file the
       document is already interactive, so the boot call sits at the end of the file, after the
       CartPopup factory below has been assigned. Locale strings come from window.OJ_cartI18n
       (emitted by the section). */
    function ready(fn){var d=document;(d.readyState=='loading')?d.addEventListener('DOMContentLoaded',fn):fn();}

    function ojCartRoot() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
    function ojCharsLeft(n) { var t = (window.OJ_cartI18n || {}).charsLeft; return t ? t.replace('[n]', n) : n + ' character' + (n > 1 ? 's' : ''); }
    function ojT(key, fallback) { var t = (window.OJ_cartI18n || {})[key]; return t == null ? fallback : t; }

    var CartPopup = function () {
        var self = {};

        self.checkEngraving = function (cart) {
            let counter = 0;
            let counter_2 = 0;
            for (i in cart.items) {
                let item = cart.items[i];
                if (item.properties && item.properties.engraving && item.properties.engraving != "") {
                    counter += item.quantity;
                }
                if (item.product_id == "7256077402304") {
                    counter_2 += item.quantity;
                }
            }
            return {
                counters_check: counter == counter_2,
                counter: counter,
                counter_2: counter_2
            };
        };

        self.checkGift = function (cart) {
            let counter = 0;
            let counter_2 = 0;
            for (i in cart.items) {
                let item = cart.items[i];
                if (item.properties && item.properties.gift_wrap) {
                    counter += item.quantity;
                }
                if (item.product_id == "7256077861056") {
                    counter_2 += item.quantity;
                }
            }
            return {
                counters_check: counter == counter_2,
                counter: counter,
                counter_2: counter_2
            };
        }

        self.handleEngraving = function (counter, counter_2, callback) {
            let url = "/cart/add.json";
            
            if (counter_2 > 0) {
                url = "/cart/change.json"  
            } 

            if (!window.engraving_product) {
                if (typeof callback == "function") {
                    callback();
                }
                return;
            }
            $.post(url, {id: window.engraving_product.variants[0].id, quantity: counter}, function (product) {
                if (typeof callback == "function") {
                callback();
                }
            });
        };

        self.handleGift = function (counter, counter_2, callback) {
            let url = "/cart/add.json";
            
            if (counter_2 > 0) {
                url = "/cart/change.json"  
            } 

            if (!window.gift_wrapping_product) {
                if (typeof callback == "function") {
                    callback();
                }
                return;
            }
            $.post(url, {id: window.gift_wrapping_product.variants[0].id, quantity: counter}, function (product) {
                if (typeof callback == "function") {
                callback();
                }
            });
        };

        self.createCartPopupItemElem = function (item_obj) {
            let product_image = 'https://via.placeholder.com/290x396';
            let item_price = typeof item_obj.final_line_price !== 'undefined' ? item_obj.final_line_price : item_obj.line_price;
            let discount_amount = 0;
            if(typeof item_obj.line_level_total_discount !== 'undefined') {
                discount_amount = item_obj.line_level_total_discount;
            } else if(item_obj.discount_allocations && item_obj.discount_allocations.length) {
                item_obj.discount_allocations.forEach(function(allocation) {
                    if(allocation.amount) {
                        discount_amount += parseFloat(allocation.amount) * 100;
                    } else if(allocation.amount_set && allocation.amount_set.shop_money && allocation.amount_set.shop_money.amount) {
                        discount_amount += parseFloat(allocation.amount_set.shop_money.amount) * 100;
                    }
                });
            }
            // final_line_price already includes line-level/cart-level discounts,
            // so leave item_price untouched to avoid double-discounting
            // original_line_price only reflects cart/line discounts, NOT a variant
            // markdown (sale price + compare-at). addCompareAtPrice() attaches the
            // per-unit variant compare_at_price, so prefer the higher of the two
            // to surface the "before vs after" strikethrough during markdown sales.
            let item_compare_at_price = item_obj.original_line_price;
            if (item_obj.compare_at_price && item_obj.compare_at_price * item_obj.quantity > item_compare_at_price) {
                item_compare_at_price = item_obj.compare_at_price * item_obj.quantity;
            }
            
            //if(item_obj.properties && item_obj.properties.engraving) {
            //    item_price += item_obj.quantity * window.engraving_product.price;
            //}
            let is_engraving = item_obj.product_id == '7256077402304';
            let is_wrapping = item_obj.product_id == '7256077861056';
            let is_calendar = item_obj.product_id == '14604242354562';
            let is_aperitivo = item_obj.product_id == '14693010669954';
            
            if(item_obj.image) {
                product_image = item_obj.image;
            }
            let item_url = item_obj.url;
            if(is_engraving || is_wrapping) {
                item_url = '#'
            }
            let html_jq = '';
            if(!window.new_design_enabled_on_cart_popup) {
                html_jq = `
                    <li>
                        <div class="cart-item-elem">
                            <div class="top-part">
                            <div class="cart-item-elem-image">
                                <a href="` + item_url + `"` + (is_engraving || is_wrapping?' class="no-link"':'') + `>
                                    <img src="` + product_image + `" alt="">
                                </a>                    
                            </div>
                            <div class="cart-item-elem-details">
                                <div class="cart-item-elem-title">
                                    <a href="` + item_url + `"` + (is_engraving || is_wrapping?' class="no-link"':'') + `>
                                        <h6>` + item_obj.product_title + `</h6>`;
                if(item_obj.properties && item_obj.properties.engraving) {
                    html_jq +=          `<p class="v4">Engraving: "` + item_obj.properties.engraving + `"</p>`;
                }
                if (item_obj.properties && item_obj.properties.gift_wrap) {
                    html_jq += `<p class="v4">Gift Wrapping`;

                    if (item_obj.properties.gift_message) {
                        html_jq += `: "${item_obj.properties.gift_message}"`;
                    }

                    html_jq += `</p>`;
                }
                html_jq +=         `</a>`;
                if(item_obj.properties && (item_obj.properties.item_1 || item_obj.properties.item_2 || item_obj.properties.item_3 || item_obj.properties.item_4 || item_obj.properties.item_5)) {
                    html_jq +=     `<p style="font-size: 8px; line-height: 10px;">`;
                    let list = '';
                    for(let i = 1; i <= 5; ++i) {
                        if(!item_obj.properties['item_' + i]) {
                            continue;                        
                        }
                        if(list == '') {
                            list = item_obj.properties['item_' + i];
                        } else {
                            list += `, ` + item_obj.properties['item_' + i];
                        }
                    }
                    html_jq += list;
                    html_jq +=     `</p>`;
                }
                
                if(item_obj.properties && (item_obj.properties.selected_88ml_perfume)) {
                    html_jq +=     `<p style="font-size: 8px; line-height: 10px; margin-bottom: 8px; margin-top: 2px;">`;
                    let list = "Selected 88ml perfume:<br>" + item_obj.properties.selected_88ml_perfume;
                    html_jq += list;
                    html_jq +=     `</p>`;
                }

                if(item_obj.properties && (item_obj.properties.selected_4_x_10ml_travels_pray)) {
                    html_jq +=     `<p style="font-size: 8px; line-height: 10px;">`;
                    let list = "Selected 4x10ml travels spray:<br>" + item_obj.properties.selected_4_x_10ml_travels_pray;
                    html_jq += list;
                    html_jq +=     `</p>`;
                }

                if(item_obj.properties && (item_obj.properties.aperitivo_selected_4_x_10ml_pray)) {
                    html_jq +=     `<p style="font-size: 8px; line-height: 10px;">`;
                    let list = "Selected 4x10ml travels spray:<br>" + item_obj.properties.aperitivo_selected_4_x_10ml_pray;
                    html_jq += list;
                    html_jq +=     `</p>`;
                }

                html_jq +=      `</div>
                                <div class="cart-item-elem-quantity">
                                    <div class="cart-item-quantity-selector` + (is_engraving || is_wrapping?' disabled':'') + `">`;
                html_jq +=             `<p class="v3">
                                            ` + item_obj.quantity + `
                                        </p>`;
                if(!is_engraving && !is_wrapping) {
                    html_jq +=         `<div class="cart-item-quantity-selector-dropdown">
                                            <ul data-variant-id="` + item_obj.key + `" ` + (is_calendar?' data-is-calendar="true" data-uuid="' + item_obj.properties.uuid + '"':'') + ` ` + (is_aperitivo?' data-is-aperitivo="true" data-uuid="' + item_obj.properties.uuid + '"':'') + `>
                                                <li data-value="1"> 1</li>
                                                <li data-value="2"> 2</li>
                                                <li data-value="3"> 3</li>
                                                <li data-value="4"> 4</li>
                                                <li data-value="5"> 5</li>
                                                <li data-value="6"> 6</li>
                                                <li data-value="7"> 7</li>
                                                <li data-value="8"> 8</li>
                                                <li data-value="9"> 9</li>
                                                <li data-value="10"> 10</li> 
                                            </ul>
                                        </div>`;
                }
                html_jq +=         `</div>
                                </div>
                                <div class="cart-item-elem-remove">`;
                if(item_obj.properties && item_obj.properties.date) {
                    let pretty_date = item_obj.properties.date;
                    if(window.consultation_calendar && typeof window.consultation_calendar.getWrittenMonth == 'function') {
                        let _date = new Date(pretty_date);
                        let _y = _date.getFullYear();
                        let _m = window.consultation_calendar.getWrittenMonth(_date.getMonth());
                        let _d = _date.getDate();
                        _d = _d < 10 ? '0' + _d : _d;
                        pretty_date = _y + ' ' + _m + ' ' + _d;
                    }
                    html_jq +=       `<p class="v5">` + pretty_date + ` | ` + item_obj.properties.time + `</p>`;
                } else if(item_obj.variant_title) {
                    html_jq +=       `<p class="v4">` + item_obj.variant_title + `</p>`;
                }
                if(!is_engraving && !is_wrapping) {
                    html_jq +=       `<a href="" data-variant-id="` + item_obj.key + `" ` + (is_calendar?' data-is-calendar="true" data-uuid="' + item_obj.properties.uuid + '"':'') + ` ` + (is_aperitivo?' data-is-aperitivo="true" data-uuid="' + item_obj.properties.uuid + '"':'') + `>` + ojT('remove', 'Remove') + `</a>`;
                }
                html_jq +=      `</div>
                                <div class="cart-item-elem-price">`;
                if(item_price <= 0 && discount_amount > 0){
                    html_jq +=          `<p class="v4">` + ojT('free', 'Free') + ` <s>` + Shopify.formatMoney(item_compare_at_price, window.money_format) + `</s></p>`;
                } else if(item_compare_at_price && item_compare_at_price > item_price) {
                    html_jq +=          `<p class="v4">` + Shopify.formatMoney(item_price, window.money_format) + ` <s>` + Shopify.formatMoney(item_compare_at_price, window.money_format) + `</s></p>`;
                } else {
                    html_jq +=          `<p class="v4">` + Shopify.formatMoney(item_price, window.money_format) + ` <s></s></p>`;
                }

                html_jq +=      `</div>
                            </div>
                            </div>
                            <div class="bottom-part"></div>
                        </div>
                    </li>       
                `;
            } else {
                // NEW DESIGN (cart drawer redesign)
                html_jq = `
                    <li>
                        <div class="cart-item-elem">
                            <a class="cart-item-elem-image` + (is_engraving || is_wrapping ? ' no-link' : '') + `" href="` + item_url + `">
                                <img src="` + product_image + `" alt="">
                            </a>
                            <div class="cart-item-elem-details">
                                <div class="cart-item-row-top">
                                    <div class="cart-item-elem-title">
                                        <a href="` + item_url + `"` + (is_engraving || is_wrapping ? ' class="no-link"' : '') + `>
                                            <h6>` + item_obj.product_title + `</h6>
                                        </a>`;
                if (item_obj.properties && item_obj.properties.engraving) {
                    html_jq += `<p class="v4">Engraving: "` + item_obj.properties.engraving + `"</p>`;
                }
                if (item_obj.properties && item_obj.properties.gift_wrap) {
                    html_jq += `<p class="v4">Gift Wrapping`;
                    if (item_obj.properties.gift_message) {
                        html_jq += `: "${item_obj.properties.gift_message}"`;
                    }
                    html_jq += `</p>`;
                }
                if (item_obj.properties && (item_obj.properties.item_1 || item_obj.properties.item_2 || item_obj.properties.item_3 || item_obj.properties.item_4 || item_obj.properties.item_5)) {
                    html_jq += `<p class="v4">`;
                    let list = '';
                    for (let i = 1; i <= 5; ++i) {
                        if (!item_obj.properties['item_' + i]) {
                            continue;
                        }
                        if (list == '') {
                            list = item_obj.properties['item_' + i];
                        } else {
                            list += `, ` + item_obj.properties['item_' + i];
                        }
                    }
                    html_jq += list;
                    html_jq += `</p>`;
                }
                if (item_obj.properties && (item_obj.properties.selected_88ml_perfume)) {
                    html_jq += `<p class="v4">` + ojT('selected88', 'Selected 88ml perfume:') + `<br>` + item_obj.properties.selected_88ml_perfume + `</p>`;
                }
                if (item_obj.properties && (item_obj.properties.selected_4_x_10ml_travels_pray)) {
                    html_jq += `<p class="v4">` + ojT('selectedTravel', 'Selected 4x10ml travels spray:') + `<br>` + item_obj.properties.selected_4_x_10ml_travels_pray + `</p>`;
                }
                if (item_obj.properties && (item_obj.properties.aperitivo_selected_4_x_10ml_pray)) {
                    html_jq += `<p class="v4">` + ojT('selectedTravel', 'Selected 4x10ml travels spray:') + `<br>` + item_obj.properties.aperitivo_selected_4_x_10ml_pray + `</p>`;
                }
                html_jq += `</div>
                                    <div class="cart-item-elem-price">`;
                if (item_price <= 0 && discount_amount > 0) {
                    html_jq += `<p class="v4"><span class="cart-item-price__sale">` + ojT('free', 'Free') + `</span> <s>` + Shopify.formatMoney(item_compare_at_price, window.money_format) + `</s></p>`;
                } else if (item_compare_at_price && item_compare_at_price > item_price) {
                    html_jq += `<p class="v4"><s>` + Shopify.formatMoney(item_compare_at_price, window.money_format) + `</s> <span class="cart-item-price__sale">` + Shopify.formatMoney(item_price, window.money_format) + `</span></p>`;
                } else {
                    html_jq += `<p class="v4">` + Shopify.formatMoney(item_price, window.money_format) + `</p>`;
                }
                html_jq += `</div>
                                </div>`;
                if (item_obj.variant_title) {
                    html_jq += `<div class="cart-item-elem-meta"><span>` + item_obj.variant_title + `</span></div>`;
                }
                if (window.OJ_collectMarketEligible && item_obj.properties && item_obj.properties._collect_in_store) {
                    html_jq += `<div class="cart-collect-pill"><svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="square"><path d="M3 9l1.6-5h14.8L21 9M4 9v10h16V9M3 9h18M9.5 19v-5h5v5"></path></svg><span>` + ((window.OJ_collectStrings && window.OJ_collectStrings.pill) || 'Collect in store only') + `</span></div>`;
                }
                html_jq += `<div class="cart-item-row-bottom">
                                    <div class="cart-page-item-quantity-selector` + (is_engraving || is_wrapping ? ' disabled' : '') + `" data-variant-id="` + item_obj.key + `" ` + (is_calendar ? ' data-is-calendar="true" data-uuid="' + item_obj.properties.uuid + '"' : '"') + ` ` + (is_aperitivo ? ' data-is-aperitivo="true" data-uuid="' + item_obj.properties.uuid + '"' : '"') + `>
                                        <button data-type="minus">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none"><path d="M3.5 8.5C3.5 8.36739 3.55268 8.24022 3.64645 8.14645C3.74021 8.05268 3.86739 8 4 8H12C12.1326 8 12.2598 8.05268 12.3536 8.14645C12.4473 8.24022 12.5 8.36739 12.5 8.5C12.5 8.63261 12.4473 8.75978 12.3536 8.85355C12.2598 8.94732 12.1326 9 12 9H4C3.86739 9 3.74021 8.94732 3.64645 8.85355C3.55268 8.75978 3.5 8.63261 3.5 8.5Z" fill="#503629"></path></svg>
                                        </button>
                                        <p class="v3">` + item_obj.quantity + `</p>
                                        <button data-type="plus">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none"><path d="M7.5 4.5C7.5 4.36739 7.55268 4.24021 7.64645 4.14645C7.74022 4.05268 7.86739 4 8 4C8.13261 4 8.25979 4.05268 8.35355 4.14645C8.44732 4.24021 8.5 4.36739 8.5 4.5V8H12C12.1326 8 12.2598 8.05268 12.3536 8.14645C12.4473 8.24022 12.5 8.36739 12.5 8.5C12.5 8.63261 12.4473 8.75979 12.3536 8.85355C12.2598 8.94732 12.1326 9 12 9H8.5V12.5C8.5 12.6326 8.44732 12.7598 8.35355 12.8536C8.25979 12.9473 8.13261 13 8 13C7.86739 13 7.74022 12.9473 7.64645 12.8536C7.55268 12.7598 7.5 12.6326 7.5 12.5V9H4C3.86739 9 3.74021 8.94732 3.64645 8.85355C3.55268 8.75979 3.5 8.63261 3.5 8.5C3.5 8.36739 3.55268 8.24022 3.64645 8.14645C3.74021 8.05268 3.86739 8 4 8H7.5V4.5Z" fill="#503629"></path></svg>
                                        </button>
                                    </div>
                                    <div class="cart-item-details-remove">`;
                if (!is_engraving && !is_wrapping) {
                    html_jq += `<a href="" data-variant-id="` + item_obj.key + `" ` + (is_calendar ? ' data-is-calendar="true" data-uuid="' + item_obj.properties.uuid + '"' : '') + ` ` + (is_aperitivo ? ' data-is-aperitivo="true" data-uuid="' + item_obj.properties.uuid + '"' : '') + `>${(window.OJ_cartI18n || {}).remove}</a>`;
                }
                html_jq += `</div>
                                </div>
                            </div>
                        </div>
                    </li>
                `;
            }

            return $(html_jq);
        };

        self.createCartPageItemElem = function (item_obj) {
            let engraving_btn_text = ojT('engravingGifting', 'engraving & Gifting');//'Add engraving';
            let engraving_btn_text_edit = ojT('edit', 'Edit');
            let engraving_btn_text_remove = ojT('remove', 'Remove');
            let properties_arr_string = [];
            let engraving_total_price = (window.engraving_product ? window.engraving_product.price : 0) * item_obj.quantity;
            let engraving = (item_obj.properties&&item_obj.properties.engraving)?item_obj.properties.engraving:'';
            let remaining_characters = Math.max(0, window.engraving_character_limit - engraving.length);
            let product_image = 'https://via.placeholder.com/80x109';
            if(item_obj.image) {
                product_image = item_obj.image;
            }
            for(key in item_obj.properties) {properties_arr_string.push([key, item_obj.properties[key]])}

            let is_engraving = item_obj.product_id == '7256077402304';
            let is_wrapping = item_obj.product_id == '7256077861056';
            let is_calendar = item_obj.product_id == '14604242354562';
            let is_aperitivo = item_obj.product_id == '14693010669954';

            let item_price = typeof item_obj.final_line_price !== 'undefined' ? item_obj.final_line_price : item_obj.line_price;
            let page_discount_amount = 0;
            if(typeof item_obj.line_level_total_discount !== 'undefined') {
                page_discount_amount = item_obj.line_level_total_discount;
            } else if(item_obj.discount_allocations && item_obj.discount_allocations.length) {
                item_obj.discount_allocations.forEach(function(allocation) {
                    if(allocation.amount) {
                        page_discount_amount += parseFloat(allocation.amount) * 100;
                    } else if(allocation.amount_set && allocation.amount_set.shop_money && allocation.amount_set.shop_money.amount) {
                        page_discount_amount += parseFloat(allocation.amount_set.shop_money.amount) * 100;
                    }
                });
            }
            // final_line_price already reflects discounts; avoid subtracting twice
            let item_url = item_obj.url;
            if(is_engraving || is_wrapping) {
                item_url = '#';
            }
            let html_jq = `
            <li>
                <div class="cart-page-item">
                    <div class="cart-page-item-body">
                        <a href="` + item_url + `"` + (is_engraving || is_wrapping?' class="no-link"':'') + `>
                            <img src="` + product_image + `" alt="">
                        </a>
                        <div class="cart-page-item-body-inner">                                            
                            <div class="cart-page-item-details-top">
                                <div class="left">
                                <div class="cart-page-item-details-title">
                                    <a href="` + item_url + `"` + (is_engraving || is_wrapping?' class="no-link"':'') + `>
                                        <h4>` + item_obj.product_title + `</h4>
                                    </a>`;      
            if(item_obj.variant_title) {
                html_jq +=      `<p class="v3">` + item_obj.variant_title + `</p>`;
            }

            if(item_obj.properties && item_obj.properties.engraving) {
                html_jq +=          `<p class="v3">Engraving: "` + item_obj.properties.engraving + `"</p>`;
            }
            if (item_obj.properties && item_obj.properties.gift_wrap) {
                html_jq += `<p class="v3">Gift Wrapping`;

                if (item_obj.properties.gift_message) {
                    html_jq += `: "${item_obj.properties.gift_message}"`;
                }

                html_jq += `</p>`;
            }
            if(item_obj.properties && (item_obj.properties.item_1 || item_obj.properties.item_2 || item_obj.properties.item_3 || item_obj.properties.item_4 || item_obj.properties.item_5)) {
                html_jq +=          `<p style="font-size: 8px; line-height: 10px;">`;
                let list = '';
                for(let i = 1; i <= 5; ++i) {
                    if(!item_obj.properties['item_' + i]) {
                        continue;                        
                    }
                    if(list == '') {
                        list = item_obj.properties['item_' + i];
                    } else {
                        list += `, ` + item_obj.properties['item_' + i];
                    }
                }
                html_jq += list;
                html_jq +=          `</p>`;
            }   
            
            if(item_obj.properties && (item_obj.properties.selected_88ml_perfume)) {
                html_jq +=     `<p style="font-size: 10px; line-height: 10px; margin-bottom: 8px; margin-top: 2px;">`;
                let list = "Selected 88ml perfume:<br>" + item_obj.properties.selected_88ml_perfume;
                html_jq += list;
                html_jq +=     `</p>`;
            }

            if(item_obj.properties && (item_obj.properties.selected_4_x_10ml_travels_pray)) {
                html_jq +=     `<p style="font-size: 10px; line-height: 10px;">`;
                let list = "Selected 4x10ml travels spray:<br>" + item_obj.properties.selected_4_x_10ml_travels_pray;
                html_jq += list;
                html_jq +=     `</p>`;
            }

            if(item_obj.properties && (item_obj.properties.aperitivo_selected_4_x_10ml_pray)) {
                html_jq +=     `<p style="font-size: 10px; line-height: 10px;">`;
                let list = "Selected 4x10ml travels spray:<br>" + item_obj.properties.aperitivo_selected_4_x_10ml_pray;
                html_jq += list;
                html_jq +=     `</p>`;
            }

            html_jq +=          `</div>`;

            html_jq +=         `<div class="cart-page-item-details-price">`;
            // Prefer the variant markdown (compare_at_price × qty) over original_line_price,
            // which only reflects cart/line discounts. See addCompareAtPrice().
            let line_compare_at_price = item_obj.original_line_price;
            if (item_obj.compare_at_price && item_obj.compare_at_price * item_obj.quantity > line_compare_at_price) {
                line_compare_at_price = item_obj.compare_at_price * item_obj.quantity;
            }
            if(item_price <= 0 && page_discount_amount > 0){
                html_jq +=              `<p class="v3">` + ojT('free', 'Free') + ` <s>` + Shopify.formatMoney(line_compare_at_price, window.money_format) + `</s></p>`;
            } else if(line_compare_at_price && line_compare_at_price > item_price) {
                html_jq +=              `<p class="v3">` + Shopify.formatMoney(item_price, window.money_format) + ` <s>` + Shopify.formatMoney(line_compare_at_price, window.money_format) + `</s></p>`;
            } else {
                html_jq +=              `<p class="v3">` + Shopify.formatMoney(item_price, window.money_format) + ` <s></s></p>`;
            }            
            html_jq +=          `</div>`;

            html_jq +=          `</div><div class="right">`;

            html_jq +=     `<div class="cart-page-item-details-remove">`;
            if(!is_engraving && !is_wrapping) {
                html_jq +=          `<a href="" data-variant-id="` + item_obj.key + `" ` + (is_calendar?' data-is-calendar="true" data-uuid="' + item_obj.properties.uuid + '"':'') + ` ` + (is_aperitivo?' data-is-aperitivo="true" data-uuid="' + item_obj.properties.uuid + '"':'') + `><svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none"><path d="M9.81484 9.006C9.81932 8.87478 9.77201 8.74707 9.68313 8.65044C9.59425 8.55381 9.47093 8.49601 9.3398 8.48953C9.20866 8.48306 9.08025 8.52841 8.98227 8.61582C8.8843 8.70322 8.82464 8.82565 8.81617 8.95667L8.66683 11.9933C8.66235 12.1245 8.70966 12.2523 8.79854 12.3489C8.88742 12.4455 9.01074 12.5033 9.14187 12.5098C9.27301 12.5163 9.40142 12.4709 9.4994 12.3835C9.59737 12.2961 9.65703 12.1737 9.6655 12.0427L9.81484 9.006ZM6.65883 8.482C6.52653 8.48856 6.40224 8.54735 6.31324 8.64547C6.22425 8.74359 6.17782 8.87302 6.18417 9.00533L6.3335 12.0433C6.33577 12.1096 6.35119 12.1747 6.37886 12.235C6.40654 12.2952 6.44593 12.3494 6.49472 12.3943C6.54352 12.4391 6.60076 12.4739 6.6631 12.4964C6.72545 12.519 6.79166 12.5289 6.85788 12.5256C6.9241 12.5224 6.98901 12.506 7.04883 12.4774C7.10865 12.4488 7.16218 12.4086 7.20632 12.3591C7.25045 12.3096 7.28431 12.2519 7.30592 12.1892C7.32752 12.1265 7.33645 12.0602 7.33217 11.994L7.18283 8.95667C7.17628 8.82424 7.11739 8.69984 7.01913 8.61083C6.92086 8.52181 6.79126 8.47547 6.65883 8.482Z" fill="#503629"></path><path d="M6.83235 1.83334C6.43453 1.83334 6.05299 1.99137 5.77169 2.27268C5.49039 2.55398 5.33235 2.93551 5.33235 3.33334V3.83334H3.66635C3.30231 3.83278 2.9505 3.96463 2.6765 4.20431C2.40249 4.44398 2.225 4.77512 2.1771 5.13599C2.12921 5.49686 2.21419 5.86284 2.41619 6.16568C2.61819 6.46853 2.92344 6.68758 3.27502 6.782L3.69368 13.7567C3.71662 14.1382 3.88436 14.4966 4.16265 14.7587C4.44093 15.0208 4.80877 15.1667 5.19102 15.1667H10.807C11.1893 15.1667 11.5571 15.0208 11.8354 14.7587C12.1137 14.4966 12.2814 14.1382 12.3043 13.7567L12.723 6.782C13.0746 6.68758 13.3798 6.46853 13.5818 6.16568C13.7838 5.86284 13.8688 5.49686 13.8209 5.13599C13.773 4.77512 13.5955 4.44398 13.3215 4.20431C13.0475 3.96463 12.6957 3.83278 12.3317 3.83334H10.6657V3.33334C10.6657 2.93551 10.5076 2.55398 10.2263 2.27268C9.94504 1.99137 9.56351 1.83334 9.16568 1.83334H6.83235ZM9.66568 3.83334H6.33235V3.33334C6.33235 3.20073 6.38503 3.07355 6.4788 2.97978C6.57256 2.88601 6.69974 2.83334 6.83235 2.83334H9.16568C9.29829 2.83334 9.42547 2.88601 9.51924 2.97978C9.613 3.07355 9.66568 3.20073 9.66568 3.33334V3.83334ZM3.66635 4.83334H12.3317C12.4643 4.83334 12.5915 4.88601 12.6852 4.97978C12.779 5.07355 12.8317 5.20073 12.8317 5.33334C12.8317 5.46594 12.779 5.59312 12.6852 5.68689C12.5915 5.78066 12.4643 5.83334 12.3317 5.83334H3.66635C3.53374 5.83334 3.40656 5.78066 3.3128 5.68689C3.21903 5.59312 3.16635 5.46594 3.16635 5.33334C3.16635 5.20073 3.21903 5.07355 3.3128 4.97978C3.40656 4.88601 3.53374 4.83334 3.66635 4.83334ZM4.27968 6.83334H11.7183L11.3063 13.6967C11.2987 13.8239 11.2428 13.9434 11.1499 14.0308C11.0571 14.1181 10.9345 14.1667 10.807 14.1667H5.19102C5.06356 14.1667 4.94089 14.1181 4.84808 14.0308C4.75528 13.9434 4.69933 13.8239 4.69168 13.6967L4.27968 6.83334Z" fill="#503629"></path></svg></a>`;
            }
            html_jq +=     `</div>`;

            html_jq +=          `<div class="cart-page-item-details-quantity">
                                    <div class="cart-page-item-quantity-selector` + (is_engraving || is_wrapping?' disabled':'') + `" data-variant-id="` + item_obj.key + `" ` + (is_calendar?' data-is-calendar="true" data-uuid="' + item_obj.properties.uuid + '"':'"') + ` ` + (is_aperitivo?' data-is-aperitivo="true" data-uuid="' + item_obj.properties.uuid + '"':'"') + `>
                                        <button data-type="minus">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none"><path d="M3.5 8.5C3.5 8.36739 3.55268 8.24022 3.64645 8.14645C3.74021 8.05268 3.86739 8 4 8H12C12.1326 8 12.2598 8.05268 12.3536 8.14645C12.4473 8.24022 12.5 8.36739 12.5 8.5C12.5 8.63261 12.4473 8.75978 12.3536 8.85355C12.2598 8.94732 12.1326 9 12 9H4C3.86739 9 3.74021 8.94732 3.64645 8.85355C3.55268 8.75978 3.5 8.63261 3.5 8.5Z" fill="#503629"></path></svg>
                                        </button>
                                        <p class="v3">
                                            ` + item_obj.quantity + `
                                        </p>
                                        <button data-type="plus">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none"><path d="M7.5 4.5C7.5 4.36739 7.55268 4.24021 7.64645 4.14645C7.74022 4.05268 7.86739 4 8 4C8.13261 4 8.25979 4.05268 8.35355 4.14645C8.44732 4.24021 8.5 4.36739 8.5 4.5V8H12C12.1326 8 12.2598 8.05268 12.3536 8.14645C12.4473 8.24022 12.5 8.36739 12.5 8.5C12.5 8.63261 12.4473 8.75979 12.3536 8.85355C12.2598 8.94732 12.1326 9 12 9H8.5V12.5C8.5 12.6326 8.44732 12.7598 8.35355 12.8536C8.25979 12.9473 8.13261 13 8 13C7.86739 13 7.74022 12.9473 7.64645 12.8536C7.55268 12.7598 7.5 12.6326 7.5 12.5V9H4C3.86739 9 3.74021 8.94732 3.64645 8.85355C3.55268 8.75979 3.5 8.63261 3.5 8.5C3.5 8.36739 3.55268 8.24022 3.64645 8.14645C3.74021 8.05268 3.86739 8 4 8H7.5V4.5Z" fill="#503629"></path></svg>
                                        </button>
                                    </div>

                                </div>
                                </div>
                            </div>
                            <div class="cart-page-item-details-bottom">`;
//            html_jq +=     `<div class="cart-page-item-details-remove">`;
//            if(item_obj.variant_title) {
//                html_jq +=      `<p class="v3">` + item_obj.variant_title + `</p>`;
//            }
//            if(!is_engraving && !is_wrapping) {
//                html_jq +=          `<a href="" data-variant-id="` + item_obj.key + `" ` + (is_calendar?' data-is-calendar="true" data-uuid="' + item_obj.properties.uuid + '"':'') + ` ` + (is_aperitivo?' data-is-aperitivo="true" data-uuid="' + item_obj.properties.uuid + '"':'') + `>` + ojT('remove', 'Remove') + `</a>`;
//            }
//            html_jq +=     `</div>`;

//            html_jq +=         `<div class="cart-page-item-details-price">`;
            
//            let line_compare_at_price = item_obj.original_line_price;
//            if(item_price <= 0 && page_discount_amount > 0){
//                html_jq +=              `<p class="v3">` + ojT('free', 'Free') + ` <s>` + Shopify.formatMoney(line_compare_at_price, window.money_format) + `</s></p>`;
//            } else if(line_compare_at_price && line_compare_at_price > item_price) {
//                html_jq +=              `<p class="v3">` + Shopify.formatMoney(item_price, window.money_format) + ` <s>` + Shopify.formatMoney(line_compare_at_price, window.money_format) + `</s></p>`;
//            } else {
//                html_jq +=              `<p class="v3">` + Shopify.formatMoney(item_price, window.money_format) + ` <s></s></p>`;
//            }
            
            
//            html_jq +=          `</div>
            html_jq +=          `
                            </div>
                        </div>
                    </div>`;


/*
            if(!is_aperitivo && !is_calendar &&
               (!window.gift_wrapping_product || item_obj.product_id != window.gift_wrapping_product.id) &&
//               (!window.engraving_product || item_obj.product_id != window.engraving_product.id) &&
               item_obj.variant_title != '10ml' && item_obj.variant_title != '4x10ml') {
//                html_jq += `<div class="add-engraving-wraper` + (item_obj.properties&&item_obj.properties.engraving?' engraved':'') + `">`;
                html_jq += `<div class="add-engraving-wraper` + ((item_obj.properties&&item_obj.properties.engraving)||(window.engraving_product && item_obj.product_id == window.engraving_product.id)?' engraved':'') + `">`;
                if(item_obj.properties&&item_obj.properties.engraving) {
                    / *
                    html_jq += `
                            <p class="v3 add-engraving-example-info">Engraving: “` + engraving + `“</p>
                            <p class="v3 add-engraving-item-price">+ ` + Shopify.formatMoney(engraving_total_price, window.money_format) + `</p>
                            <a href="" class="add-engraving-remover">` + engraving_btn_text_remove + `</a>
                            <a href="" class="add-engraving-edit">` + engraving_btn_text_edit + `</a>
                            <a href="" class="add-engraving-opener" style="display: none;">` + engraving_btn_text + `</a>
                    `;
                    * /
                    html_jq += `
                        <p class="v3 add-engraving-example-info" style="display: none;"></p>
                        <p class="v3 add-engraving-item-price" style="display: none;"></p>
                        <a href="" class="add-engraving-remover" style="display: none;">` + engraving_btn_text_remove + `</a>
                        <a href="" class="add-engraving-edit" style="display: none;">` + engraving_btn_text_edit + `</a>
                        <a href="" class="add-engraving-opener">` + engraving_btn_text + `</a>
                    `;
                } else {
                    if(!window.engraving_product || item_obj.product_id != window.engraving_product.id) {
                        html_jq += `
                            <p class="v3 add-engraving-example-info" style="display: none;"></p>
                            <p class="v3 add-engraving-item-price" style="display: none;"></p>
                            <a href="" class="add-engraving-remover" style="display: none;">` + engraving_btn_text_remove + `</a>
                            <a href="" class="add-engraving-edit" style="display: none;">` + engraving_btn_text_edit + `</a>
                            <a href="" class="add-engraving-opener">` + engraving_btn_text + `</a>
                        `;
                    }
                }
                html_jq += `<div class="add-engraving-body">
                                <h5>${ojT('engravingTitle', 'ENGRAVING')} <a href="" class="add-engraving-cancel">${ojT('cancel', 'Cancel')}</a></h5>
                                <p class="v3">${ojT('engravingIntro', 'Simply fill in your desired lettering in the message box below.<br>Cost is £15 per item engraved and orders with engraving will arrive within 7-10 working days with standard delivery.')}</p>
                                <a href="" class="see-how-it-works">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"> <g id="Icon_ionic-ios-information-circle-outline" data-name="Icon ionic-ios-information-circle-outline" transform="translate(-3.375 -3.375)"> <path id="Path_7" data-name="Path 7" d="M16.552,11.57a.892.892,0,1,1,.887.865A.866.866,0,0,1,16.552,11.57Zm.061,1.545h1.653v6.235H16.612Z" transform="translate(-5.068 -2.821)" fill="#4e3629"></path> <path id="Path_8" data-name="Path 8" d="M12.375,4.587a7.785,7.785,0,1,1-5.508,2.28,7.737,7.737,0,0,1,5.508-2.28m0-1.212a9,9,0,1,0,9,9,9,9,0,0,0-9-9Z" fill="#4e3629"></path> </g></svg>
                                    <span>${ojT('seeHow', 'See how it works')}</span>
                                </a>
                                <div class="see-how-it-works-lightbox">
                                    <img src="` + window.engraving_see_how_it_works_image + `" alt="">
                                </div>
                                <h6>${ojT('yourMessage', 'YOUR MESSAGE')}</h6>
                                <textarea maxlength="` + window.engraving_character_limit + `" placeholder="${ojT('writeMessage', 'Write message')}" data-original="` + (item_obj.properties&&item_obj.properties.engraving?item_obj.properties.engraving:'') + `">` + (item_obj.properties&&item_obj.properties.engraving?item_obj.properties.engraving:'') + `</textarea>
                                <p class="v4 character-counter">` + ojCharsLeft(remaining_characters) + `</p>
                                <button data-line-item-key="` + item_obj.key + `" data-item-properties="` + escape(JSON.stringify(properties_arr_string)) + `" data-variant-id="` + item_obj.variant_id + `" class="save-engraving-btn">${ojT('save', 'SAVE')}</button>

                                <div class="engraving-message-update-loader">
                                    <svg version="1.1" id="loader-1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="40px" height="40px" viewBox="0 0 50 50" style="enable-background:new 0 0 50 50;" xml:space="preserve"> <path fill="#000" d="M25.251,6.461c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615V6.461z"> <animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="0.6s" repeatCount="indefinite"></animateTransform> </path> </svg>
                                </div>
                            </div>
                        </div>`;
            } else {
                if(window.new_design_enabled_on_cart_popup) {
                    html_jq += `<div class="add-engraving-wraper engraved"></div>`;
                }
            } 
*/

            const is_valid_item = !is_aperitivo && !is_calendar &&
                (!window.gift_wrapping_product || item_obj.product_id != window.gift_wrapping_product.id) &&
                (!window.engraving_product || item_obj.product_id != window.engraving_product.id);

            if (is_valid_item) {
                const is_small_variant = item_obj.variant_title == '10ml' || item_obj.variant_title == '2 x 10ml' || item_obj.variant_title == '4x10ml';
                const has_no_engraving_tag = window.no_engraving_products && window.no_engraving_products[item_obj.product_id];
                const hide_engraving = is_small_variant || has_no_engraving_tag;
                const engraving = item_obj.properties?.engraving || '';
                const gift_wrap = item_obj.properties?.gift_wrap || '';
                const gift_message = item_obj.properties?.gift_message || '';

                const has_engraving = !!engraving;

                html_jq += `<div class="add-engraving-wraper${has_engraving ? ' engraved' : ''}">`;

                const opener_label = hide_engraving ? ojT('gifting', 'Gifting') : ojT('engravingGifting', 'Engraving & Gifting');

                html_jq += `
                    <p class="v3 add-engraving-example-info" style="display: none;"></p>
                    <p class="v3 add-engraving-item-price" style="display: none;"></p>
                    <a href="" class="add-engraving-remover" style="display: none;">${engraving_btn_text_remove}</a>
                    <a href="" class="add-engraving-edit" style="display: none;">${engraving_btn_text_edit}</a>
                    <a
                        href=""
                        class="add-engraving-opener"
                        data-engraving="${engraving}"
                        data-gift-wrap="${gift_wrap}"
                        data-gift-message="${gift_message}"
                        data-variant-id="${item_obj.variant_id}"
                        data-line-item-key="${item_obj.key}"
                        data-small="${is_small_variant ? "true": "false"}"
                        data-no-engraving="${hide_engraving ? "true": "false"}"
                        data-q="${item_obj.quantity}"
                    >${opener_label}</a>
                `;

                if (!is_small_variant) {
                    html_jq += `
                        <div class="add-engraving-body">
                            <h5>${ojT('engravingTitle', 'ENGRAVING')} <a href="" class="add-engraving-cancel">${ojT('cancel', 'Cancel')}</a></h5>
                            <p class="v3">${ojT('engravingIntro', 'Simply fill in your desired lettering in the message box below.<br>Cost is £15 per item engraved and orders with engraving will arrive within 7-10 working days with standard delivery.')}</p>
                            <a href="" class="see-how-it-works">
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
                                    <g id="Icon_ionic-ios-information-circle-outline" transform="translate(-3.375 -3.375)">
                                        <path d="M16.552,11.57a.892.892,0,1,1,.887.865A.866.866,0,0,1,16.552,11.57Zm.061,1.545h1.653v6.235H16.612Z" transform="translate(-5.068 -2.821)" fill="#4e3629"></path>
                                        <path d="M12.375,4.587a7.785,7.785,0,1,1-5.508,2.28,7.737,7.737,0,0,1,5.508-2.28m0-1.212a9,9,0,1,0,9,9,9,9,0,0,0-9-9Z" fill="#4e3629"></path>
                                    </g>
                                </svg>
                                <span>${ojT('seeHow', 'See how it works')}</span>
                            </a>
                            <div class="see-how-it-works-lightbox">
                                <img src="${window.engraving_see_how_it_works_image}" alt="">
                            </div>
                            <h6>${ojT('yourMessage', 'YOUR MESSAGE')}</h6>
                            <textarea maxlength="${window.engraving_character_limit}" placeholder="${ojT('writeMessage', 'Write message')}" data-original="${engraving}">${engraving}</textarea>
                            <p class="v4 character-counter">${ojCharsLeft(remaining_characters)}</p>
                            <button 
                                data-line-item-key="${item_obj.key}" 
                                data-item-properties="${escape(JSON.stringify(properties_arr_string))}" 
                                data-variant-id="${item_obj.variant_id}" 
                                class="save-engraving-btn">${ojT('save', 'SAVE')}
                            </button>

                            <div class="engraving-message-update-loader">
                                <svg version="1.1" id="loader-1" xmlns="http://www.w3.org/2000/svg" width="40px" height="40px" viewBox="0 0 50 50">
                                    <path fill="#000" d="M25.251,6.461c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615V6.461z">
                                        <animateTransform attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="0.6s" repeatCount="indefinite" />
                                    </path>
                                </svg>
                            </div>
                        </div>
                    `;
                }

                html_jq += `</div>`;
            } else {
                if (window.new_design_enabled_on_cart_popup) {
                    html_jq += `<div class="add-engraving-wraper engraved"></div>`;
                }
            }


            html_jq += `</div>
            </li>            
            `;
            
            return $(html_jq);
        };

        // Travel Compendium Helper Functions
        self.isTravelCompendiumItem = function(item) {
            return item.properties && item.properties._travel_compendium === 'true';
        };

        self.is88mlItem = function(item) {
            // Check if variant title contains 88ml or if product has 88ml tag
            return (item.variant_title && item.variant_title.indexOf('88ml') > -1) ||
                   (item.properties && item.properties._is_88ml === 'true');
        };

        self.groupTravelCompendiumItems = function(items) {
            const groups = {
                compendium: [],  // Array of { fragrance: item, travelSet: item, savings: number }
                regular: []
            };

            // Find Travel Sets with compendium property
            const travelSetItems = items.filter(function(item) {
                return self.isTravelCompendiumItem(item);
            });

            // Track which items have been grouped
            const groupedItemKeys = [];

            // Match each Travel Set with its paired 88ml variant
            travelSetItems.forEach(function(travelSet) {
                // Look for the 88ml variant ID stored in properties
                const paired88mlVariantId = travelSet.properties._paired_with_88ml_variant;
                // Also check legacy property for backwards compatibility
                const pairedProductId = travelSet.properties._paired_with_product || travelSet.properties._paired_with_88ml;

                // Find the 88ml item - match by variant_id first, then by product_id
                let fragrance = null;
                if (paired88mlVariantId) {
                    fragrance = items.find(function(item) {
                        return String(item.variant_id) === String(paired88mlVariantId);
                    });
                }
                // Fallback to product_id matching for legacy
                if (!fragrance && pairedProductId) {
                    fragrance = items.find(function(item) {
                        return String(item.product_id) === String(pairedProductId) &&
                               item.variant_title === '88ml';
                    });
                }

                if (fragrance) {
                    // Calculate savings
                    const originalPrice = travelSet.original_line_price || travelSet.line_price;
                    const discountedPrice = travelSet.final_line_price || travelSet.line_price;
                    const savings = originalPrice - discountedPrice;

                    groups.compendium.push({
                        fragrance: fragrance,
                        travelSet: travelSet,
                        savings: savings
                    });

                    groupedItemKeys.push(fragrance.key);
                    groupedItemKeys.push(travelSet.key);
                } else {
                    // Travel Set without paired 88ml - shouldn't happen, but handle gracefully
                    groups.regular.push(travelSet);
                    groupedItemKeys.push(travelSet.key);
                }
            });

            // Add non-compendium items to regular
            items.forEach(function(item) {
                if (!groupedItemKeys.includes(item.key)) {
                    groups.regular.push(item);
                }
            });

            return groups;
        };

        self.createTravelCompendiumGroupHtml = function(group) {
            const fragranceHtml = self.createCartPopupItemElem(group.fragrance).prop('outerHTML');
            const travelSetHtml = self.createCartPopupItemElem(group.travelSet).prop('outerHTML');
            const savingsFormatted = Shopify.formatMoney(group.savings, window.money_format);

            const html = `
                <div class="tc-cart-group" data-tc-group="true" data-fragrance-key="${group.fragrance.key}" data-travel-set-key="${group.travelSet.key}">
                    <h6 class="tc-cart-group__title">${ojT('travelCompendium', 'Your Travel Compendium')}</h6>
                    <ul class="tc-cart-group__items">
                        ${fragranceHtml}
                        ${travelSetHtml}
                    </ul>
                    <div class="tc-cart-group__savings">
                        You saved <strong>${savingsFormatted}</strong> with the Travel Compendium.
                    </div>
                </div>
            `;

            return $(html);
        };

        self.removeTravelCompendiumPair = function(fragranceKey, travelSetKey, callback) {
            // Remove both items
            const updates = {};
            updates[fragranceKey] = 0;
            updates[travelSetKey] = 0;

            $.post('/cart/update.js', { updates: updates }, function() {
                // Show removal message
                self.showTravelCompendiumRemovalMessage();
                if (typeof callback === 'function') {
                    callback();
                }
            });
        };

        self.showTravelCompendiumRemovalMessage = function() {
            const message = `
                <div class="tc-removal-message">
                    The Travel Compendium requires an 88ml fragrance, so your Travel Set has been removed.
                </div>
            `;
            $('.cart-popup-content').prepend(message);
            // Auto-remove after 5 seconds
            setTimeout(function() {
                $('.tc-removal-message').fadeOut(300, function() {
                    $(this).remove();
                });
            }, 5000);
        };

        self.showTravelCompendiumHint = function(itemKey) {
            // Show hint when Travel Set is removed but 88ml remains
            const hint = `
                <div class="tc-cart-hint" data-hint-for="${itemKey}">
                    You can still enjoy 40% off any 4×10ml Travel Set with this 88ml.
                </div>
            `;
            const itemLi = $('[data-variant-id="' + itemKey + '"]').closest('li');
            if (itemLi.length && !itemLi.find('.tc-cart-hint').length) {
                itemLi.after(hint);
            }
        };

        // Cart Page specific helper functions
        self.createTravelCompendiumGroupHtmlCartPage = function(group) {
            const fragranceHtml = self.createCartPageItemElem(group.fragrance).prop('outerHTML');
            const travelSetHtml = self.createCartPageItemElem(group.travelSet).prop('outerHTML');
            const savingsFormatted = Shopify.formatMoney(group.savings, window.money_format);

            const html = `
                <div class="tc-cart-group" data-tc-group="true" data-fragrance-key="${group.fragrance.key}" data-travel-set-key="${group.travelSet.key}">
                    <h6 class="tc-cart-group__title">${ojT('travelCompendium', 'Your Travel Compendium')}</h6>
                    <ul class="tc-cart-group__items">
                        ${fragranceHtml}
                        ${travelSetHtml}
                    </ul>
                    <div class="tc-cart-group__savings">
                        You saved <strong>${savingsFormatted}</strong> with the Travel Compendium.
                    </div>
                </div>
            `;

            return $(html);
        };

        self.showTravelCompendiumHintCartPage = function(itemKey) {
            const hint = `
                <div class="tc-cart-hint" data-hint-for="${itemKey}">
                    You can still enjoy 40% off any 4×10ml Travel Set with this 88ml.
                </div>
            `;
            const itemLi = $('.cart-page-item-list [data-variant-id="' + itemKey + '"]').closest('li');
            if (itemLi.length && !itemLi.find('.tc-cart-hint').length) {
                itemLi.after(hint);
            }
        };

        self.showEmptyState = function () {
            let bag_empty_state_text = window.bag_empty_state_text ? window.bag_empty_state_text : (window.OJ_cartI18n || {}).bagEmpty;
            if(window.new_design_enabled_on_cart_popup) {
                let empty_title = (window.OJ_cartI18n || {}).emptyTitle;
                let empty_text = (window.OJ_cartI18n || {}).emptyText;
                let empty_cta = (window.OJ_cartI18n || {}).emptyCta;
                let empty_html = '<div class="cart-popup-empty">' +
                    '<div class="cart-popup-empty__icon">◇</div>' +
                    '<div class="cart-popup-empty__title">' + empty_title + '</div>' +
                    '<p class="cart-popup-empty__text">' + empty_text + '</p>' +
                    '<a class="cart-popup-empty__cta" href="' + ((window.OJ_cartI18n || {}).allProductsUrl || '/collections/all') + '">' + empty_cta + '</a>' +
                '</div>';
                $('.cart-popup-content .cart-popup-empty').remove();
                $('.cart-popup-content').append($(empty_html));
                $('.cart-popup').addClass('cart-popup--empty');
            } else {
                $('.cart-popup-content ul').append($('<li><p class="v3">' + bag_empty_state_text + '</o></li>'));
            }
        };

        self.showEmptyStateOnCartPage = function () {
            let bag_empty_state_text = window.bag_empty_state_text ? window.bag_empty_state_text : (window.OJ_cartI18n || {}).bagEmpty;
            $('.cart-page-item-list ul').append($('<li><p class="v3">' + bag_empty_state_text + '</o></li>'));
        };

        self.updateCartPopup = function (callback) {
            self.startLoadingState();
            $.getJSON(ojCartRoot() + 'cart', function (cart) {
                self.addCompareAtPrice(cart, function () {
                    $('.cart-popup-content ul.line-items').empty();
                    $('.cart-popup-content .cart-popup-empty').remove();
                    $('.cart-popup').removeClass('cart-popup--empty');
                    // Remove any previous Travel Compendium groups
                    $('.cart-popup-content .tc-cart-group').remove();
                    $('.cart-popup-content .tc-removal-message').remove();

                    // Filter out calendar/aperitivo items first
                    const filteredItems = cart.items.filter(function(item) {
                        return !self.checkCalendarItem(item) && !self.checkAperitivoItem(item);
                    });

                    /* CAMPAIGN ENDED - Travel Compendium grouping disabled. To reactivate:
                    const groups = self.groupTravelCompendiumItems(filteredItems);
                    groups.compendium.forEach(function(group) {
                        const groupElem = self.createTravelCompendiumGroupHtml(group);
                        $('.cart-popup-content ul.line-items').before(groupElem);
                    });
                    groups.regular.forEach(function(item_obj) {
                        let item_elem = self.createCartPopupItemElem(item_obj);
                        $('.cart-popup-content ul.line-items').append(item_elem);
                    });
                    */

                    // Render all items normally (Travel Compendium campaign ended)
                    filteredItems.forEach(function(item_obj) {
                        let item_elem = self.createCartPopupItemElem(item_obj);
                        $('.cart-popup-content ul.line-items').append(item_elem);
                    });

                    if(!cart.items.length) {
                        self.showEmptyState();
                    }

                    /* CAMPAIGN ENDED - Travel Compendium hint disabled
                    if (window._tcShowHintFor) {
                        self.showTravelCompendiumHint(window._tcShowHintFor);
                        window._tcShowHintFor = null;
                    }
                    */

                    self.updateSelfCart(cart);
                    self.addCartPopupItemListeners();
                    self.updateItemCount(cart);
                    self.updateSubtotal(cart);
                    /* US members sale: policy note and stock for sale lines (assets/oj-members-sale-bag.js) */
                    if (window.ojMembersSale && typeof window.ojMembersSale.decorate === 'function') { window.ojMembersSale.decorate(cart, 'drawer'); }
                    
                    if(false) {
                        $('.cart-popup-footer .free-10ml-wrapper').remove();
                        $('.cart-popup-content').removeClass('with-free-10ml');
                        if(cart.items.some(function(item){ return item.variant_title && item.variant_title.indexOf('88ml') > -1; }) &&
                        !cart.items.some(function(item){ return item.variant_title && item.variant_title.indexOf('10ml') > -1; })) {
                            var message = document.createElement('div');
                            message.className = 'free-10ml-message';
                            var wrapper = document.createElement('div');
                            wrapper.className = 'free-10ml-wrapper';
                            var msgText = window.free_10ml_message_text || "You're eligible for a complimentary 10ml.";
                            var msgLink = window.free_10ml_message_link || "/collections/10ml-free";
                            var msgLinkText = window.free_10ml_message_link_text || "Click here to choose";
                            message.innerHTML = '<p>' + msgText + '</p><p><a href="' + msgLink + '" class="underline">' + msgLinkText + '</a></p>';
                            wrapper.appendChild(message);
                            $('.cart-popup-content').addClass('with-free-10ml');
                            document.querySelector('.cart-popup-footer')?.prepend(wrapper);
                        }
                    }
                    
                    if(typeof callback == 'function') {
                        callback();
                    }
                    self.stopLoadingState();
                    
                    if(typeof minOrderCost == 'function') {
                        minOrderCost(cart.total_price / 100); //form minimum-order-cost-js.liquid
                    }
                });
            });
        };

        self.updateCartPage = function (callback) {
            self.startLoadingStateOnCartPage();
            $.getJSON(ojCartRoot() + 'cart', function (cart) {
                self.addCompareAtPrice(cart, function () {
                    $('.cart-page-item-list ul').empty();
                    // Remove any previous Travel Compendium groups
                    $('.cart-page-item-list .tc-cart-group').remove();
                    $('.cart-page-item-list .tc-removal-message').remove();

                    // Filter out calendar/aperitivo items first
                    const filteredItems = cart.items.filter(function(item) {
                        return !self.checkCalendarItem(item) && !self.checkAperitivoItem(item);
                    });

                    /* CAMPAIGN ENDED - Travel Compendium grouping disabled. To reactivate:
                    const groups = self.groupTravelCompendiumItems(filteredItems);
                    groups.compendium.forEach(function(group) {
                        const groupElem = self.createTravelCompendiumGroupHtmlCartPage(group);
                        $('.cart-page-item-list ul').before(groupElem);
                    });
                    groups.regular.forEach(function(item_obj) {
                        let item_elem = self.createCartPageItemElem(item_obj);
                        $('.cart-page-item-list ul').append(item_elem);
                    });
                    */

                    // Render all items normally (Travel Compendium campaign ended)
                    filteredItems.forEach(function(item_obj) {
                        let item_elem = self.createCartPageItemElem(item_obj);
                        $('.cart-page-item-list ul').append(item_elem);
                    });

                    if(!cart.items.length) {
                        self.showEmptyStateOnCartPage();
                    }

                    /* CAMPAIGN ENDED - Travel Compendium hint disabled
                    if (window._tcShowHintForCartPage) {
                        self.showTravelCompendiumHintCartPage(window._tcShowHintForCartPage);
                        window._tcShowHintForCartPage = null;
                    }
                    */
                    self.updateSelfCart(cart);
                    self.addCartPageItemListeners();
                    self.updateItemCount(cart);
                    self.updateSubtotalOnCartPage(cart);
                    /* US members sale: policy note and stock for sale lines (assets/oj-members-sale-bag.js) */
                    if (window.ojMembersSale && typeof window.ojMembersSale.decorate === 'function') { window.ojMembersSale.decorate(cart, 'page'); }
                    if(typeof callback == 'function') {
                        callback();
                    }
                    self.stopLoadingStateOnCartPage();
                    
                    if(typeof minOrderCost == 'function') {
                        minOrderCost(cart.total_price / 100); //form minimum-order-cost-js.liquid
                    }
                });
            });
        };        

        self.addCartPopupOpenerListener = function () {
            $(document).on('click', '.nav-bag-li a', function (event) {
                event.preventDefault();
                self.updateCartPopup(function () {
                    $('.cart-popup-wrapper').addClass('open');
                    $('html').removeClass('cart-popup-wrapper-open');
                    $('html').addClass('cart-popup-wrapper-open');
                });
                self.updateCartPage();
                return false;
            });
        };

        self.addCartPopupOpenerListenerMobile = function () {
            $(document).on('click', '.mobile-bag', function (event) {
                event.preventDefault();
                self.updateCartPopup(function () {
                    $('.cart-popup-wrapper').addClass('open');
                    $('html').removeClass('cart-popup-wrapper-open');
                    $('html').addClass('cart-popup-wrapper-open');
                });
                self.updateCartPage();
                return false;
            });
        };

        self.startLoadingState = function () {
            if(window.new_design_enabled_on_cart_popup) {
                self.startLoadingStateOnCartPage();
            }
            $('.cart-popup-loader').removeClass('show');
            $('.cart-popup-loader').addClass('show');
        };

        self.stopLoadingState = function () {
            if(window.new_design_enabled_on_cart_popup) {
                self.stopLoadingStateOnCartPage();
            }
            $('.cart-popup-loader').removeClass('show');
        };

        self.startLoadingStateOnCartPage = function () {
            $('.cart-page-loader').removeClass('show');
            $('.cart-page-loader').addClass('show');
        };

        self.stopLoadingStateOnCartPage = function () {
            $('.cart-page-loader').removeClass('show');
        };

        self.startEngravingMessageUpdateLoadingState = function (elem) {
            $(elem).find('.engraving-message-update-loader').removeClass('show');
            $(elem).find('.engraving-message-update-loader').addClass('show');
        };

        self.stopEngravingMessageUpdateLoadingState = function (elem) {
            $(elem).find('.engraving-message-update-loader').removeClass('show');
        };

        self.addCartPopupCloserListeners = function () {
            $('.cart-popup-wrapper').on('click', function (event) {
                if($(event.target).hasClass('cart-popup-wrapper')) {
                    event.preventDefault(); 
                    $(event.target).removeClass('open'); 
                    $('html').removeClass('cart-popup-wrapper-open'); 
                    return false;
                }
            });

            $('.cart-popup-close').on('click', function (event) {
                $('.cart-popup-wrapper').removeClass('open');
                $('html').removeClass('cart-popup-wrapper-open');
            });

            $(document).on('click', '.cart-popup-continue', function (event) {
                event.preventDefault();
                $('.cart-popup-wrapper').removeClass('open');
                $('html').removeClass('cart-popup-wrapper-open');
                return false;
            });
        };

        self.addListeners = function () {
            self.addCartPopupOpenerListener();
            self.addCartPopupOpenerListenerMobile();
            self.addCartPopupCloserListeners();

            self.addCartPageItemListeners();

            if(window.new_design_enabled_on_cart_popup) {
                self.addRemoveEngravingCartPopupListener();
            }
        };

        self.addRemoveEngravingCartPopupListener = function () {
            $('.remove-engraving button').on('click', function (event) {
                event.preventDefault();
                if(!confirm(ojT('dropEngravings', 'Drop all engravings from all items?'))) {
                    return false;
                }
                self.startLoadingState();
                fetch(ojCartRoot() + 'cart.js')
                .then(response => response.json())
                .then(cart => {
                    const deletionQueue = [];
                    const itemsToReAdd = [];

                    cart.items.forEach(item => {
                        const isTargetVariant = item.variant_id === 42739032490176;

                        const hasEngraving =
                        item.properties &&
                        Object.keys(item.properties).some(key => key.toLowerCase().trim() === 'engraving');

                        if (isTargetVariant || hasEngraving) {
                            deletionQueue.push(item.key);
                        }

                        if (hasEngraving) {
                            const newProps = {};
                            for (const key in item.properties) {
                                if (key.toLowerCase().trim() !== 'engraving') {
                                    newProps[key] = item.properties[key];
                                }
                            }

                            itemsToReAdd.push({
                                id: item.variant_id,
                                quantity: item.quantity,
                                properties: newProps
                            });
                        }
                    });

                    // Step 1: delete sequentially
                    const deleteSequentially = deletionQueue.reduce((promiseChain, key) => {
                        return promiseChain.then(() => {
                            return fetch(ojCartRoot() + 'cart/change.js', {
                                method: 'POST',
                                headers: { 'Content-Type': 'application/json' },
                                body: JSON.stringify({ id: key, quantity: 0 })
                            });
                        });
                    }, Promise.resolve());

                    // Step 2: wait + re-add, then continue
                    deleteSequentially
                        .then(() => new Promise(resolve => setTimeout(resolve, 500)))
                        .then(() => {
                            if (itemsToReAdd.length === 0) return;

                            return fetch(ojCartRoot() + 'cart/add.js', {
                                method: 'POST',
                                headers: { 'Content-Type': 'application/json' },
                                body: JSON.stringify({ items: itemsToReAdd })
                            });
                        })
                        .then(() => {
                            console.log('Cart update complete.');
                            self.updateCartPopup();
                            self.updateCartPage();
                        })
                        .catch(error => {
                            console.error('Cart update failed:', error);
                            self.stopLoadingState();
                        });
                    })
                    .catch(error => {
                        console.error('Cart fetch failed:', error);
                        self.stopLoadingState();
                    });

                return false;
            });
        };

        self.addCartPopupItemQuantitySelectorTogglerListener = function () {
            $('.cart-item-quantity-selector').on('click', function (event) {
                if($(event.target).hasClass('cart-item-quantity-selector')) {
                    $(this).toggleClass('open');
                }
            });
        };

        self.addCartPageItemQuantitySelectorTogglerListener = function () {
            $('.cart-page-item-quantity-selector:not(.disabled)').on('click', function (event) {
                if($(event.target).hasClass('cart-page-item-quantity-selector')) {
                    $(this).toggleClass('open');
                }
            });
        };

        self.updateItemCount = function (cart) {
            //$('.item-count').html(cart.item_count);

            let item_count = 0;
            for(let i = 0; i < cart.items.length; i++) {
                let item_obj = cart.items[i];
                if(self.checkCalendarItem(item_obj)) {
                    continue;
                }
                if(self.checkAperitivoItem(item_obj)) {
                    continue;
                }
                //item_count++;
                item_count+=item_obj.quantity;
            }
            $('.item-count').html(item_count);
        };

        self.checkCalendarItem = function(item_obj) {
            if(!item_obj.sku) {
                return false;
            }
            if(item_obj.sku.indexOf('88ml') == 0 || item_obj.sku.indexOf('10ml') == 0) {
                return true;
            }
            return false
        }

        self.checkAperitivoItem = function(item_obj) {
            // todo - on what basis do we check?
            if(!item_obj.sku) {
                return false;
            }
            if(item_obj.sku.indexOf('10ml') == 0) {
                return true;
            }
            return false
        }

        // Update complimentary shipping status dynamically
        self.updateCompShipping = function (cartTotal) {
            var $compShipping = $('[data-comp-shipping]');
            if (!$compShipping.length) return;

            var threshold = parseInt($compShipping.attr('data-threshold')) || 0;
            var currency = $compShipping.attr('data-currency') || 'GBP';
            var regionName = $compShipping.attr('data-region-name') || '';
            var shippingTerm = $compShipping.attr('data-shipping-term') || 'shipping';
            var qualifiedMessage = $compShipping.attr('data-qualified-message') || '';
            var progressMessage = $compShipping.attr('data-progress-message') || '';
            var almostMessage = $compShipping.attr('data-almost-message') || '';

            var remaining = threshold - cartTotal;
            var progressPercent = Math.min((cartTotal / threshold) * 100, 100);

            // Format remaining amount
            var remainingFormatted = Shopify.formatMoney(remaining, window.money_format);

            // Determine status and message
            var newClass, newMessage;
            if (cartTotal >= threshold) {
                newClass = 'green';
                newMessage = qualifiedMessage;
            } else if (progressPercent >= 50) {
                newClass = 'red';
                newMessage = almostMessage.replace('{amount}', remainingFormatted);
            } else if (cartTotal > 0) {
                newClass = 'red';
                newMessage = progressMessage.replace('{amount}', remainingFormatted);
            } else {
                newClass = 'info';
                var thresholdFormatted = $compShipping.attr('data-threshold-formatted') || Shopify.formatMoney(threshold, window.money_format);
                newMessage = (window.OJ_cartI18n || {}).shipUnlockTemplate.replace('[region]', regionName).replace('[threshold]', thresholdFormatted).replace('[term]', shippingTerm);
            }

            // Update classes
            $compShipping.removeClass('red green info').addClass(newClass);

            // Update message
            $compShipping.find('.comp-shipping__message').text(newMessage);

            // Update progress bar if it exists
            var $progressBar = $compShipping.find('.comp-shipping__progress-bar');
            if ($progressBar.length) {
                $progressBar.css('width', progressPercent + '%');
            }

            // Show/hide progress bar based on cart state
            var $progress = $compShipping.find('.comp-shipping__progress');
            if ($progress.length) {
                if (cartTotal > 0 && cartTotal < threshold) {
                    $progress.show();
                } else {
                    $progress.hide();
                }
            }
        };

        self.updateSubtotal = function (cart) {
            let engraving_total_price = self.getEngravingTotalPrice();
            if(engraving_total_price > 0) {
                $('.cart-popup-footer .cart-engraving-sub-total').show();
                $('.cart-popup-footer .cart-engraving-sub-total p').html('+' + Shopify.formatMoney(engraving_total_price, window.money_format));
            } else {
                $('.cart-popup-footer .cart-engraving-sub-total').hide();
            }
            let gift_wrapping_total_price = self.getGiftWrappingTotalPrice();
            if(gift_wrapping_total_price > 0) {
                $('.cart-popup-footer .cart-gift-wrapping-sub-total').show();
                $('.cart-popup-footer .cart-gift-wrapping-sub-total p').html('+' + Shopify.formatMoney(gift_wrapping_total_price, window.money_format));
            } else {
                $('.cart-popup-footer .cart-gift-wrapping-sub-total').hide();
            }

            $('.cart-popup-footer .cart-sub-total p').html(Shopify.formatMoney(cart.total_price, window.money_format));

            let cart_total_compare_at_price = self.calcCartTotalCompareAtPrice(cart);
            let cart_savings = (cart_total_compare_at_price && cart_total_compare_at_price > cart.total_price) ? (cart_total_compare_at_price - cart.total_price) : 0;
            if(window.new_design_enabled_on_cart_popup) {
                // Redesigned drawer surfaces total savings on its own row instead of
                // a strikethrough beside the subtotal.
                if(cart_savings > 0) {
                    $('.cart-popup-footer .cart-savings-sub-total').show();
                    $('.cart-popup-footer .cart-savings-sub-total p').html('-' + Shopify.formatMoney(cart_savings, window.money_format));
                } else {
                    $('.cart-popup-footer .cart-savings-sub-total').hide();
                }
            } else if(cart_total_compare_at_price && cart_total_compare_at_price > cart.total_price) {
                $('.cart-popup-footer .cart-sub-total p').append('&nbsp;');
                $('.cart-popup-footer .cart-sub-total p').append($('<s>' + Shopify.formatMoney(cart_total_compare_at_price, window.money_format + '</s>')));
            }

            // Collect in store only: bottom summary panel ("N to collect in store").
            try {
                var collectCount = 0;
                for (var ci in cart.items) {
                    var it = cart.items[ci];
                    if (it.properties && it.properties._collect_in_store) {
                        collectCount += it.quantity;
                    }
                }
                var $cs = $('.cart-popup-footer .cart-collect-summary');
                if (window.new_design_enabled_on_cart_popup && window.OJ_collectMarketEligible && collectCount > 0) {
                    var strs = window.OJ_collectStrings || {};
                    var head = collectCount + ' ' + (strs.summaryTitle || 'to collect in store');
                    var note = strs.summaryNote || 'These will be reserved at the Royal Arcade boutique and cannot be posted.';
                    var collectHtml = '<div class="cart-collect-summary">'
                        + '<div class="cart-collect-summary__head"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="square"><path d="M3 9l1.6-5h14.8L21 9M4 9v10h16V9M3 9h18M9.5 19v-5h5v5"></path></svg><span>' + head + '</span></div>'
                        + '<p>' + note + '</p>'
                        + '</div>';
                    if ($cs.length) { $cs.replaceWith(collectHtml); }
                    else { $('.cart-popup-footer .cart-sub-total').before(collectHtml); }
                } else {
                    $cs.remove();
                }
            } catch (e) {}

            // Update complimentary shipping status
            self.updateCompShipping(cart.total_price);
        };

        self.calcCartTotalCompareAtPrice = function (cart) {
            let cart_total_compare_at_price = 0;
            for(i in cart.items) {
                let item = cart.items[i];
                if(item.compare_at_price) {
                    cart_total_compare_at_price += (item.compare_at_price * item.quantity);
                } else {
                    cart_total_compare_at_price += (item.price * item.quantity);
                }
            }    
            return cart_total_compare_at_price;
        };

        self.getEngravingTotalPrice = function () {
            /*
            let counter = 0;
            for(i in self.cart.items) {
                let item = self.cart.items[i];
                if(item.properties && item.properties.engraving && item.properties.engraving.length > 0) {
                    counter += item.quantity;
                }
            }
            return counter * window.engraving_price;
            */
            if (window.engraving_product) {
                for(i in self.cart.items) {
                    if(self.cart.items[i].product_id == window.engraving_product.id) {
                        return self.cart.items[i].quantity * window.engraving_product.price;
                    }
                }
            }
            return 0;
        };

        self.getGiftWrappingTotalPrice = function () {
            //if(window.cart_popup.cart.attributes.gift_wrapping) {
                //return 1000;
            //}
            if (window.gift_wrapping_product) {
                let cart_has_gift_wrapping_product = false;
                let cart_gift_wrapping_product_counter = 0;
                for(i in self.cart.items) {
                    if(self.cart.items[i].product_id == window.gift_wrapping_product.id) {
                        cart_has_gift_wrapping_product = true;
//                        break;
                        cart_gift_wrapping_product_counter += self.cart.items[i].quantity;
                    }
                }
                if(cart_has_gift_wrapping_product && cart_gift_wrapping_product_counter > 0) {
                    return window.gift_wrapping_product.price * cart_gift_wrapping_product_counter;
                }
            }
            return 0;
        };

        self.updateSubtotalOnCartPage = function (cart) {
            let engraving_total_price = self.getEngravingTotalPrice();
            if(engraving_total_price > 0) {
                $('.summary-content .overall-engraving-price').show();
                $('.summary-content .overall-engraving-price span').html('+' + Shopify.formatMoney(engraving_total_price, window.money_format));
            } else {
                $('.summary-content .overall-engraving-price').hide();
            }
            let gift_wrapping_total_price = self.getGiftWrappingTotalPrice();
            if(gift_wrapping_total_price > 0) {
                $('.overall-gift-wrapping-price').show();
                $('.overall-gift-wrapping-price span').html('+' + Shopify.formatMoney(gift_wrapping_total_price, window.money_format));
            } else {
                $('.overall-gift-wrapping-price').hide();
            }
            let total_price = cart.total_price;// + engraving_total_price + gift_wrapping_total_price;
            $('.summary-content .overall-subtotal-price span').html(Shopify.formatMoney(total_price, window.money_format));

            let cart_total_compare_at_price = self.calcCartTotalCompareAtPrice(cart);
            if(cart_total_compare_at_price && cart_total_compare_at_price > cart.total_price) {
                $('.summary-content .overall-subtotal-price span').append('&nbsp;');
                $('.summary-content .overall-subtotal-price span').append($('<s>' + Shopify.formatMoney(cart_total_compare_at_price, window.money_format + '</s>')));
            }

            // Update complimentary shipping status
            self.updateCompShipping(cart.total_price);
        };

        self.get88mlVariantKey = function (cart, uuid) {
            for(let i = 0; i < cart.items.length; ++i) {
                if(cart.items[i] && cart.items[i].properties && cart.items[i].properties.uuid == uuid && cart.items[i].title.indexOf('88ml') > -1) {
                    return cart.items[i].variant_id;
                }
            }
            return '';
        };
        
        self.get10mlVariantKeys = function (cart, uuid) {
            let ids = [];
            for(let i = 0; i < cart.items.length; ++i) {
                if(cart.items[i] && cart.items[i].properties&& cart.items[i].properties.uuid == uuid && cart.items[i].title.indexOf('10ml') > -1) {
                    ids.push(cart.items[i].variant_id);
                }
            }
            return ids;
        };

        self.get10mlVariantKeysAperitivo = function (cart, uuid) {
            let ids = [];
            for(let i = 0; i < cart.items.length; ++i) {
                if(cart.items[i] && cart.items[i].properties&& cart.items[i].properties.uuid == uuid && cart.items[i].title.indexOf('10ml') > -1) {
                    ids.push(cart.items[i].variant_id);
                }
            }
            return ids;
        };
        
        self.addCartPopupItemQuantitySelectorListener = function () {
            $('.cart-item-quantity-selector-dropdown ul li').on('click', function () {
                var _this = this; 
                var quantity = $(_this).data().value; 
                var variant_id = $(_this.parentNode).data().variantId;  
                var is_calendar = $(_this.parentNode).data().isCalendar;                 
                var is_aperitivo = $(_this.parentNode).data().isAperitivo;
                var uuid = $(_this.parentNode).data().uuid;                 
                var updates = {};
                updates[variant_id] = quantity;

                self.startLoadingState();
                $.post('/cart/update.js', { updates }, function (cart) {
                    cart = JSON.parse(cart);
                    let line_item = self.getItem(cart, variant_id);
                    /* US members sale: a sale line Shopify kept below the asked quantity is told inside the bag, not with alert() */
                    let ms_quantity = (window.ojMembersSale && typeof window.ojMembersSale.capped === 'function') ? window.ojMembersSale.capped(cart, variant_id, quantity) : null;
                    if(ms_quantity !== null) {
                        quantity = ms_quantity;
                    } else if(line_item && quantity != line_item.quantity) {
                        quantity = line_item.quantity;
                        alert('Can\'t  add more then ' + quantity + ' ' + line_item.title + ' into the cart');
                    }

                    if(is_calendar) {
                        var calendar_update_data = {};
                        let _88ml_variant_id = self.get88mlVariantKey(cart, uuid);
                        let _10ml_variant_ids = self.get10mlVariantKeys(cart, uuid);
                        calendar_update_data[_88ml_variant_id] = quantity;

                        for(let i = 0; i < _10ml_variant_ids.length; ++i) {
                            calendar_update_data[_10ml_variant_ids[i]] = quantity;
                        }

                        $.post('/cart/update.js', { updates: calendar_update_data }, function (updatesCart) {
                            updatesCart = JSON.parse(updatesCart);

                            setTimeout(function () {
                                $(_this.parentNode.parentNode.parentNode).removeClass('open');
                                self.updateCartPopup();
                                self.updateCartPage();
                            }, 50);
                        });
                    } else if(is_aperitivo) {
                        // todo
                        var aperitivo_update_data = {};
                        let _10ml_variant_ids = self.get10mlVariantKeysAperitivo(cart, uuid);
                        
                        for(let i = 0; i < _10ml_variant_ids.length; ++i) {
                            aperitivo_update_data[_10ml_variant_ids[i]] = quantity;
                        }

                        $.post('/cart/update.js', { updates: aperitivo_update_data }, function (updatesCart) {
                            updatesCart = JSON.parse(updatesCart);

                            setTimeout(function () {
                                $(_this.parentNode.parentNode.parentNode).removeClass('open');
                                self.updateCartPopup();
                                self.updateCartPage();
                            }, 50);
                        });
                    } else {
                        /*
                        let check_engraving = self.checkEngraving(cart);
                        if (check_engraving.counters_check) {
                            $(_this.parentNode.parentNode.parentNode).find('p').html(quantity); 
                            setTimeout(function () {
                                $(_this.parentNode.parentNode.parentNode).removeClass('open');
                                self.updateCartPopup();
                                self.updateCartPage();
                            }, 50);
                        } else {
                            self.handleEngraving(check_engraving.counter, check_engraving.counter_2, function() {
                                $(_this.parentNode.parentNode.parentNode).find('p').html(quantity); 
                                setTimeout(function () {
                                    $(_this.parentNode.parentNode.parentNode).removeClass('open');
                                    self.updateCartPopup();
                                    self.updateCartPage();
                                }, 50);
                            });
                        }
                        */

                        let check_engraving = self.checkEngraving(cart);
                        let check_gift = self.checkGift(cart);

                        const updateDOMandUI = function () {
                            $(_this.parentNode.parentNode.parentNode).find('p').html(quantity); 
                            setTimeout(function () {
                                $(_this.parentNode.parentNode.parentNode).removeClass('open');
                                self.updateCartPopup();
                                self.updateCartPage();
                            }, 50);
                        };

                        if (check_engraving.counters_check && check_gift.counters_check) {
                            // engraving OK, gift OK
                            updateDOMandUI();
                        } else if (check_engraving.counters_check) {
                            // engraving OK, gift NO -> handleGift
                            self.handleGift(check_gift.counter, check_gift.counter_2, function () {
                                updateDOMandUI();
                            });
                        } else if (check_gift.counters_check) {
                            // gift OK, engraving NO -> handleEngraving
                            self.handleEngraving(check_engraving.counter, check_engraving.counter_2, function () {
                                updateDOMandUI();
                            });
                        } else {
                            // gift NO, engraving NO
                            self.handleEngraving(check_engraving.counter, check_engraving.counter_2, function () {
                                self.handleGift(check_gift.counter, check_gift.counter_2, function () {
                                    updateDOMandUI();
                                });
                            });
                        }
                    }
                });
            });
        };

        self.getItem = function (cart, variant_id) {
            let current_line_item_quantity = 0;
            let line_item = null;
            for(let i = 0; i < cart.items.length; i++) {
                if(cart.items[i].variant_id == variant_id) {
                    line_item = cart.items[i];
                    break;
                }
            }
            return line_item;
        };

        self.addCartPageItemQuantityIncreaseListener = function () {
            $('.cart-page-item-quantity-selector button[data-type="plus"]').off('click');
            $('.cart-page-item-quantity-selector button[data-type="plus"]').on('click', function (event) {
                event.preventDefault();
                var _this = this; 
                var quantity_selector = $(_this).closest('.cart-page-item-quantity-selector');
                if(quantity_selector.hasClass('disabled')) {
                    return false;
                }
                let quantity = parseInt(quantity_selector.find('p').html());
                    
                if(isNaN(quantity) || quantity < 1) {
                    return; // error?
                }

                quantity += 1;
                var variant_id = quantity_selector.data().variantId; 
                var is_calendar = quantity_selector.data().isCalendar;                 
                var is_aperitivo = quantity_selector.data().isAperitivo;
                var uuid = quantity_selector.data().uuid;                 
                
                var updates = {};
                updates[variant_id] = quantity;

                self.startLoadingState();
                //self.startLoadingStateOnCartPage();
                $.post('/cart/update.js', { updates }, function (cart) {
                    //cart = JSON.parse(cart);
                    let line_item = self.getItem(cart, variant_id);
                    /* US members sale: a sale line Shopify kept below the asked quantity is told inside the bag, not with alert() */
                    let ms_quantity = (window.ojMembersSale && typeof window.ojMembersSale.capped === 'function') ? window.ojMembersSale.capped(cart, variant_id, quantity) : null;
                    if(ms_quantity !== null) {
                        quantity = ms_quantity;
                    } else if(line_item && quantity != line_item.quantity) {
                        quantity = line_item.quantity;
                        alert('Can\'t  add more then ' + quantity + ' ' + line_item.title + ' into the cart');
                    }

                    if(is_calendar) {
                        var calendar_update_data = {};
                        let _88ml_variant_id = self.get88mlVariantKey(cart, uuid);
                        let _10ml_variant_ids = self.get10mlVariantKeys(cart, uuid);
                        calendar_update_data[_88ml_variant_id] = quantity;

                        for(let i = 0; i < _10ml_variant_ids.length; ++i) {
                            calendar_update_data[_10ml_variant_ids[i]] = quantity;
                        }

                        $.post('/cart/update.js', { updates: calendar_update_data }, function (updatesCart) {
                            updatesCart = JSON.parse(updatesCart);

                            setTimeout(function () {
                                self.updateAfterCartPageQuantityChange(_this, quantity, updatesCart.item_count, updatesCart);
                            }, 100);
                        });
                    } else if(is_aperitivo) {
                        // todo
                        var aperitivo_update_data = {};
                        let _10ml_variant_ids = self.get10mlVariantKeysAperitivo(cart, uuid);
                        
                        for(let i = 0; i < _10ml_variant_ids.length; ++i) {
                            aperitivo_update_data[_10ml_variant_ids[i]] = quantity;
                        }

                        $.post('/cart/update.js', { updates: aperitivo_update_data }, function (updatesCart) {
                            updatesCart = JSON.parse(updatesCart);

                            setTimeout(function () {
                                self.updateAfterCartPageQuantityChange(_this, quantity, updatesCart.item_count, updatesCart);
                            }, 100);
                        });
                    } else {
                        /*
                        let check_engraving = self.checkEngraving(cart);
                        if (check_engraving.counters_check) {
                            self.updateAfterCartPageQuantityChange(_this, quantity, cart.item_count, cart);
                        } else {
                            self.handleEngraving(check_engraving.counter, check_engraving.counter_2, function() {
                                self.updateAfterCartPageQuantityChange(_this, quantity, cart.item_count + (check_engraving.counter_2 - check_engraving.counter), cart);
                            });
                        }
                        */

                        let check_engraving = self.checkEngraving(cart);
                        let check_gift = self.checkGift(cart); 

                        if (check_engraving.counters_check && check_gift.counters_check) {
                            // engraving OK, gift OK
                            setTimeout(function () {
                                self.updateAfterCartPageQuantityChange(_this, quantity, cart.item_count, cart);
                            }, 100);
                        } else if (check_engraving.counters_check) {
                            // engraving OK, gift NO
                            self.handleGift(check_gift.counter, check_gift.counter_2, function () {
                                let new_count = cart.item_count + (check_gift.counter - check_gift.counter_2);
                                setTimeout(function () {
                                    self.updateAfterCartPageQuantityChange(_this, quantity, new_count, cart);
                                }, 100);
                            });
                        } else if (check_gift.counters_check) {
                            // gift OK, engraving NO
                            self.handleEngraving(check_engraving.counter, check_engraving.counter_2, function () {
                                let new_count = cart.item_count + (check_engraving.counter - check_engraving.counter_2);
                                setTimeout(function () {
                                    self.updateAfterCartPageQuantityChange(_this, quantity, new_count, cart);
                                }, 100);
                            });
                        } else {
                            // gift NO, engraving NO
                            self.handleEngraving(check_engraving.counter, check_engraving.counter_2, function () {
                                self.handleGift(check_gift.counter, check_gift.counter_2, function () {
                                    let engraving_diff = check_engraving.counter - check_engraving.counter_2;
                                    let gift_diff = check_gift.counter - check_gift.counter_2;
                                    let new_count = cart.item_count + engraving_diff + gift_diff;

                                    setTimeout(function () {
                                        self.updateAfterCartPageQuantityChange(_this, quantity, new_count, cart);
                                    }, 100);
                                });
                            });
                        }
                    }
                }, 'json');       
            });
        };

        self.addCartPageItemQuantityDecreaseListener = function () {
            $('.cart-page-item-quantity-selector button[data-type="minus"]').off('click');
            $('.cart-page-item-quantity-selector button[data-type="minus"]').on('click', function (event) {
                event.preventDefault();
                var _this = this; 
                var quantity_selector = $(_this).closest('.cart-page-item-quantity-selector');
                if(quantity_selector.hasClass('disabled')) {
                    return false;
                }
                let quantity = parseInt(quantity_selector.find('p').html());
                    
                if(isNaN(quantity) || quantity < 1) {
                    return; // error?
                }

                /* Down to zero removes the line: reuse the remove flow (handles travel sets, calendars and gifts). */
                if (quantity === 1) {
                    var remove_link = quantity_selector.closest('.cart-item-row-bottom').find('.cart-item-details-remove a');
                    if (remove_link.length) {
                        remove_link.trigger('click');
                        return false;
                    }
                }

                quantity -= 1;
                var variant_id = quantity_selector.data().variantId; 
                var is_calendar = quantity_selector.data().isCalendar;                 
                var is_aperitivo = quantity_selector.data().isAperitivo;
                var uuid = quantity_selector.data().uuid;                 
                
                var updates = {};
                updates[variant_id] = quantity;

                self.startLoadingState();
                //self.startLoadingStateOnCartPage();
                $.post('/cart/update.js', { updates }, function (cart) {
                    //cart = JSON.parse(cart);
                    let line_item = self.getItem(cart, variant_id);
                    /* US members sale: a sale line Shopify kept below the asked quantity is told inside the bag, not with alert() */
                    let ms_quantity = (window.ojMembersSale && typeof window.ojMembersSale.capped === 'function') ? window.ojMembersSale.capped(cart, variant_id, quantity) : null;
                    if(ms_quantity !== null) {
                        quantity = ms_quantity;
                    } else if(line_item && quantity != line_item.quantity) {
                        quantity = line_item.quantity;
                        alert('Can\'t  add more then ' + quantity + ' ' + line_item.title + ' into the cart');
                    }

                    if(is_calendar) {
                        var calendar_update_data = {};
                        let _88ml_variant_id = self.get88mlVariantKey(cart, uuid);
                        let _10ml_variant_ids = self.get10mlVariantKeys(cart, uuid);
                        calendar_update_data[_88ml_variant_id] = quantity;

                        for(let i = 0; i < _10ml_variant_ids.length; ++i) {
                            calendar_update_data[_10ml_variant_ids[i]] = quantity;
                        }

                        $.post('/cart/update.js', { updates: calendar_update_data }, function (updatesCart) {
                            updatesCart = JSON.parse(updatesCart);

                            setTimeout(function () {
                                self.updateAfterCartPageQuantityChange(_this, quantity, updatesCart.item_count, updatesCart);
                            }, 100);
                        });
                    } else if(is_aperitivo) {
                        // todo
                        var aperitivo_update_data = {};
                        let _10ml_variant_ids = self.get10mlVariantKeysAperitivo(cart, uuid);
                        
                        for(let i = 0; i < _10ml_variant_ids.length; ++i) {
                            aperitivo_update_data[_10ml_variant_ids[i]] = quantity;
                        }

                        $.post('/cart/update.js', { updates: aperitivo_update_data }, function (updatesCart) {
                            updatesCart = JSON.parse(updatesCart);

                            setTimeout(function () {
                                self.updateAfterCartPageQuantityChange(_this, quantity, updatesCart.item_count, updatesCart);
                            }, 100);
                        });
                    } else {
                        /*
                        let check_engraving = self.checkEngraving(cart);
                        if (check_engraving.counters_check) {
                            self.updateAfterCartPageQuantityChange(_this, quantity, cart.item_count, cart);
                        } else {
                            self.handleEngraving(check_engraving.counter, check_engraving.counter_2, function() {
                                self.updateAfterCartPageQuantityChange(_this, quantity, cart.item_count + (check_engraving.counter_2 - check_engraving.counter), cart);
                            });
                        }
                        */

                        let check_engraving = self.checkEngraving(cart);
                        let check_gift = self.checkGift(cart);

                        if (check_engraving.counters_check && check_gift.counters_check) {
                            // engraving OK, gift OK
                            setTimeout(function () {
                                self.updateAfterCartPageQuantityChange(_this, quantity, cart.item_count, cart);
                            }, 100);
                        } else if (check_engraving.counters_check) {
                            // engraving OK, gift NO
                            self.handleGift(check_gift.counter, check_gift.counter_2, function () {
                                let new_count = cart.item_count + (check_gift.counter - check_gift.counter_2);
                                setTimeout(function () {
                                    self.updateAfterCartPageQuantityChange(_this, quantity, new_count, cart);
                                }, 100);
                            });
                        } else if (check_gift.counters_check) {
                            // gift OK, engraving NO
                            self.handleEngraving(check_engraving.counter, check_engraving.counter_2, function () {
                                let new_count = cart.item_count + (check_engraving.counter - check_engraving.counter_2);
                                setTimeout(function () {
                                    self.updateAfterCartPageQuantityChange(_this, quantity, new_count, cart);
                                }, 100);
                            });
                        } else {
                            // gift NO, engraving NO
                            self.handleEngraving(check_engraving.counter, check_engraving.counter_2, function () {
                                self.handleGift(check_gift.counter, check_gift.counter_2, function () {
                                    let engraving_diff = check_engraving.counter - check_engraving.counter_2;
                                    let gift_diff = check_gift.counter - check_gift.counter_2;
                                    let new_count = cart.item_count + engraving_diff + gift_diff;

                                    setTimeout(function () {
                                        self.updateAfterCartPageQuantityChange(_this, quantity, new_count, cart);
                                    }, 100);
                                });
                            });
                        }
                    }
                }, 'json');                
            });
        };

        self.addCartPageItemQuantitySelectorListener = function () {
            $('.cart-page-item-quantity-selector-dropdown ul li').on('click', function () {
                var _this = this; 
                var quantity = $(_this).data().value; 
                var variant_id = $(_this.parentNode).data().variantId; 
                var is_calendar = $(_this.parentNode).data().isCalendar;                 
                var is_aperitivo = $(_this.parentNode).data().isAperitivo;
                var uuid = $(_this.parentNode).data().uuid;                 
                var updates = {};
                updates[variant_id] = quantity;

                self.startLoadingStateOnCartPage();
                $.post('/cart/update.js', { updates }, function (cart) {
                    cart = JSON.parse(cart);
                    let line_item = self.getItem(cart, variant_id);
                    /* US members sale: a sale line Shopify kept below the asked quantity is told inside the bag, not with alert() */
                    let ms_quantity = (window.ojMembersSale && typeof window.ojMembersSale.capped === 'function') ? window.ojMembersSale.capped(cart, variant_id, quantity) : null;
                    if(ms_quantity !== null) {
                        quantity = ms_quantity;
                    } else if(line_item && quantity != line_item.quantity) {
                        quantity = line_item.quantity;
                        alert('Can\'t  add more then ' + quantity + ' ' + line_item.title + ' into the cart');
                    }

                    if(is_calendar) {
                        var calendar_update_data = {};
                        let _88ml_variant_id = self.get88mlVariantKey(cart, uuid);
                        let _10ml_variant_ids = self.get10mlVariantKeys(cart, uuid);
                        calendar_update_data[_88ml_variant_id] = quantity;

                        for(let i = 0; i < _10ml_variant_ids.length; ++i) {
                            calendar_update_data[_10ml_variant_ids[i]] = quantity;
                        }

                        $.post('/cart/update.js', { updates: calendar_update_data }, function (updatesCart) {
                            updatesCart = JSON.parse(updatesCart);

                            setTimeout(function () {
                                self.updateAfterCartPageQuantityChange(_this, quantity, updatesCart.item_count, updatesCart);
                            }, 50);
                        });
                    } else if(is_aperitivo) {
                        // todo
                        var aperitivo_update_data = {};
                        let _10ml_variant_ids = self.get10mlVariantKeysAperitivo(cart, uuid);
                        
                        for(let i = 0; i < _10ml_variant_ids.length; ++i) {
                            aperitivo_update_data[_10ml_variant_ids[i]] = quantity;
                        }

                        $.post('/cart/update.js', { updates: aperitivo_update_data }, function (updatesCart) {
                            updatesCart = JSON.parse(updatesCart);

                            setTimeout(function () {
                                self.updateAfterCartPageQuantityChange(_this, quantity, updatesCart.item_count, updatesCart);
                            }, 50);
                        });
                    } else {
                        /*
                        let check_engraving = self.checkEngraving(cart);
                        if (check_engraving.counters_check) {
                            self.updateAfterCartPageQuantityChange(_this, quantity, cart.item_count, cart);
                        } else {
                            self.handleEngraving(check_engraving.counter, check_engraving.counter_2, function() {
                                self.updateAfterCartPageQuantityChange(_this, quantity, cart.item_count + (check_engraving.counter_2 - check_engraving.counter), cart);
                            });
                        }
                        */

                        let check_engraving = self.checkEngraving(cart);
                        let check_gift = self.checkGift(cart);

                        if (check_engraving.counters_check && check_gift.counters_check) {
                            // engraving OK, gift OK
                            self.updateAfterCartPageQuantityChange(_this, quantity, cart.item_count, cart);
                        } else if (check_engraving.counters_check) {
                            // engraving OK, gift NO
                            self.handleGift(check_gift.counter, check_gift.counter_2, function () {
                                let new_count = cart.item_count + (check_gift.counter - check_gift.counter_2);
                                self.updateAfterCartPageQuantityChange(_this, quantity, new_count, cart);
                            });
                        } else if (check_gift.counters_check) {
                            // gift OK, engraving NO
                            self.handleEngraving(check_engraving.counter, check_engraving.counter_2, function () {
                                let new_count = cart.item_count + (check_engraving.counter - check_engraving.counter_2);
                                self.updateAfterCartPageQuantityChange(_this, quantity, new_count, cart);
                            });
                        } else {
                            // gift NO, engraving NO
                            self.handleEngraving(check_engraving.counter, check_engraving.counter_2, function () {
                                self.handleGift(check_gift.counter, check_gift.counter_2, function () {
                                    let engraving_diff = check_engraving.counter - check_engraving.counter_2;
                                    let gift_diff = check_gift.counter - check_gift.counter_2;
                                    let new_count = cart.item_count + engraving_diff + gift_diff;

                                    self.updateAfterCartPageQuantityChange(_this, quantity, new_count, cart);
                                });
                            });
                        }
                    }
                });
            });
        };

        self.updateAfterCartPageQuantityChange = function (_this, quantity, cart_item_count, cart) {
            //$(_this.parentNode.parentNode.parentNode).find('p').html(quantity); 
            setTimeout(function () {
                $(_this.parentNode.parentNode.parentNode).removeClass('open');
                //$('.item-count').html(cart_item_count);
                self.updateItemCount(cart);                
                self.updateCartPage();
                self.updateCartPopup();
            }, 50);
        };

        self.addCartPopupItemRemoveListener = function () {
            let q = '.cart-item-elem-remove a';
            if(window.new_design_enabled_on_cart_popup) {
                q = '.cart-item-details-remove a';
            }
            $(q).on('click', function (event) {
                event.preventDefault();
                let variant_id = $(this).data().variantId;
                let is_calendar = $(this).data().isCalendar;
                let is_aperitivo = $(this).data().isAperitivo;
                let uuid = $(this).data().uuid;
                let quantity = 0;

                // Check if this item is part of a Travel Compendium group
                const tcGroup = $(this).closest('.tc-cart-group');
                if (tcGroup.length) {
                    const fragranceKey = tcGroup.data('fragranceKey');
                    const travelSetKey = tcGroup.data('travelSetKey');
                    const clickedKey = String(variant_id);

                    // If removing the 88ml fragrance, remove both items
                    if (clickedKey === String(fragranceKey)) {
                        self.removeTravelCompendiumPair(fragranceKey, travelSetKey, function() {
                            self.updateCartPopup();
                            self.updateCartPage();
                        });
                        return false;
                    }
                    // If removing just the Travel Set, proceed with normal removal
                    // (the 88ml stays and gets a hint)
                }

                $.post('/cart/change.json', {id: variant_id, quantity: quantity}, function (cart) {
                    // Check if a Travel Set was removed that was part of compendium
                    // Show hint on remaining 88ml if applicable
                    const removedItem = self.cart && self.cart.items ? self.cart.items.find(function(item) {
                        return item.key === variant_id;
                    }) : null;

                    if (removedItem && self.isTravelCompendiumItem(removedItem)) {
                        const paired88mlId = removedItem.properties._paired_with_88ml;
                        const remaining88ml = cart.items.find(function(item) {
                            return String(item.product_id) === String(paired88mlId);
                        });
                        if (remaining88ml) {
                            // Will show hint after cart updates
                            window._tcShowHintFor = remaining88ml.key;
                        }
                    }
                    if(is_calendar) {
                        var calendar_update_data = {};
                        let _88ml_variant_id = self.get88mlVariantKey(cart, uuid);
                        let _10ml_variant_ids = self.get10mlVariantKeys(cart, uuid);
                        
                        calendar_update_data[_88ml_variant_id] = quantity;

                        for(let i = 0; i < _10ml_variant_ids.length; ++i) {
                            calendar_update_data[_10ml_variant_ids[i]] = quantity;
                        }

                        $.post('/cart/update.js', { updates: calendar_update_data }, function (updatesCart) {
                            updatesCart = JSON.parse(updatesCart);

                            self.updateCartPopup();
                            self.updateCartPage();
                        });
                    } else if(is_aperitivo) {
                        // todo
                        var aperitivo_update_data = {};
                        let _10ml_variant_ids = self.get10mlVariantKeysAperitivo(cart, uuid);
                    
                        for(let i = 0; i < _10ml_variant_ids.length; ++i) {
                            aperitivo_update_data[_10ml_variant_ids[i]] = quantity;
                        }

                        $.post('/cart/update.js', { updates: aperitivo_update_data }, function (updatesCart) {
                            updatesCart = JSON.parse(updatesCart);

                            self.updateCartPopup();
                            self.updateCartPage();
                        });
                    } else {
                        /*
                        let check_engraving = self.checkEngraving(cart);
                        if (check_engraving.counters_check) {
                            self.updateCartPopup();
                            self.updateCartPage();
                        } else {
                            self.handleEngraving(check_engraving.counter, check_engraving.counter_2, function () {
                                self.updateCartPopup();
                                self.updateCartPage();
                            });
                        }
                        */
                        let check_engraving = self.checkEngraving(cart);
                        let check_gift = self.checkGift(cart);
                        if (check_engraving.counters_check && check_gift.counters_check) {
                            // engraving OK, gift OK
                            self.updateCartPopup();
                            self.updateCartPage();
                        } else if (check_engraving.counters_check) {
                            // engraving OK, gift NO
                            self.handleGift(check_gift.counter, check_gift.counter_2, function () {
                                self.updateCartPopup();
                                self.updateCartPage();
                            });
                        } else if (check_gift.counters_check) {
                            // gift OK, engraving NO
                            self.handleEngraving(check_engraving.counter, check_engraving.counter_2, function () {
                                self.updateCartPopup();
                                self.updateCartPage();
                            });
                        } else {
                            // engraving NO, gift NO
                            self.handleEngraving(check_engraving.counter, check_engraving.counter_2, function () {
                                self.handleGift(check_gift.counter, check_gift.counter_2, function () {
                                    self.updateCartPopup();
                                    self.updateCartPage();
                                });
                            });
                        }
                    }
                });
                return false;
            });
        };

        self.addCartPageItemRemoveListener = function () {
            //$('.cart-page-item-list ul li .cart-page-item .cart-page-item-details-remove a').on('click', function (event) {
            $('.cart-page-item-details-remove a').on('click', function (event) {
                event.preventDefault();
                let variant_id = $(this).data().variantId;
                let is_calendar = $(this).data().isCalendar;
                let is_aperitivo = $(this).data().isAperitivo;
                let uuid = $(this).data().uuid;
                let quantity = 0;

                // Check if this item is part of a Travel Compendium group
                const tcGroup = $(this).closest('.tc-cart-group');
                if (tcGroup.length) {
                    const fragranceKey = tcGroup.data('fragranceKey');
                    const travelSetKey = tcGroup.data('travelSetKey');
                    const clickedKey = String(variant_id);

                    // If removing the 88ml fragrance, remove both items
                    if (clickedKey === String(fragranceKey)) {
                        self.removeTravelCompendiumPair(fragranceKey, travelSetKey, function() {
                            self.updateCartPage();
                            self.updateCartPopup();
                        });
                        return false;
                    }
                }

                let data_to_send = {id: variant_id, quantity: quantity};
                $.post('/cart/change.json', data_to_send, function (cart) {
                    // Check if a Travel Set was removed that was part of compendium
                    const removedItem = self.cart && self.cart.items ? self.cart.items.find(function(item) {
                        return item.key === variant_id;
                    }) : null;

                    if (removedItem && self.isTravelCompendiumItem(removedItem)) {
                        const paired88mlId = removedItem.properties._paired_with_88ml;
                        const remaining88ml = cart.items.find(function(item) {
                            return String(item.product_id) === String(paired88mlId);
                        });
                        if (remaining88ml) {
                            window._tcShowHintForCartPage = remaining88ml.key;
                            window._tcShowHintFor = remaining88ml.key;
                        }
                    }
                    if(is_calendar) {
                        var calendar_update_data = {};
                        let _88ml_variant_id = self.get88mlVariantKey(cart, uuid);
                        let _10ml_variant_ids = self.get10mlVariantKeys(cart, uuid);
                        
                        calendar_update_data[_88ml_variant_id] = quantity;

                        for(let i = 0; i < _10ml_variant_ids.length; ++i) {
                            calendar_update_data[_10ml_variant_ids[i]] = quantity;
                        }

                        $.post('/cart/update.js', { updates: calendar_update_data }, function (updatesCart) {
                            updatesCart = JSON.parse(updatesCart);
                            self.updateCartPage();
                            self.updateCartPopup();                            
                        });
                    } else if(is_aperitivo) {
                        //todo
                        var aperitivo_update_data = {};
                        let _10ml_variant_ids = self.get10mlVariantKeysAperitivo(cart, uuid);
                        
                        for(let i = 0; i < _10ml_variant_ids.length; ++i) {
                            aperitivo_update_data[_10ml_variant_ids[i]] = quantity;
                        }

                        $.post('/cart/update.js', { updates: aperitivo_update_data }, function (updatesCart) {
                            updatesCart = JSON.parse(updatesCart);
                            self.updateCartPage();
                            self.updateCartPopup();                            
                        });
                    } else {
                        /*
                        let check_engraving = self.checkEngraving(cart);
                        if (check_engraving.counters_check) {
                            self.updateCartPage();
                            self.updateCartPopup();
                        } else {
                            self.handleEngraving(check_engraving.counter, check_engraving.counter_2, self.updateCartPage);
                        }
                        */
                        let check_engraving = self.checkEngraving(cart);
                        let check_gift = self.checkGift(cart);

                        if (check_engraving.counters_check && check_gift.counters_check) {
                            // engraving OK, gift OK
                            self.updateCartPage();
                            self.updateCartPopup();
                        } else if (check_engraving.counters_check) {
                            // engraving OK, gift NO
                            self.handleGift(check_gift.counter, check_gift.counter_2, function () {
                                self.updateCartPage();
                                self.updateCartPopup();
                            });
                        } else if (check_gift.counters_check) {
                            // gift OK, engraving NO
                            self.handleEngraving(check_engraving.counter, check_engraving.counter_2, function () {
                                self.updateCartPage();
                                self.updateCartPopup();
                            });
                        } else {
                            // engraving NO, gift NO
                            self.handleEngraving(check_engraving.counter, check_engraving.counter_2, function () {
                                self.handleGift(check_gift.counter, check_gift.counter_2, function () {
                                    self.updateCartPage();
                                    self.updateCartPopup();
                                });
                            });
                        }

                    }
                });
                return false;
            });
        };

        self.cartPageEGMOpen = function (btn) {
            $('#engravingGiftingModal').modal('toggle');

            const engraving = btn.data('engraving');
            const giftWrap = btn.data('gift-wrap');
            const giftMessage = btn.data('gift-message');
            const variantId = btn.data('variant-id');
            const itemKey = btn.data('line-item-key');
            const small = btn.data('small');
            const quantity = btn.data('q');
            const noEngraving = btn.data('no-engraving');

            console.log("cartPageEGMOpen datas:");
            console.log({ engraving, giftWrap, giftMessage, variantId, itemKey, small, quantity, noEngraving});

            self.egmUpdateWithDatas(engraving, giftWrap, giftMessage, variantId, itemKey, small, quantity, noEngraving);
        }

        self.egmUpdateWithDatas = function (engraving, giftWrap, giftMessage, variantId, itemKey, small, quantity, noEngraving) {
            if (window.egm_on_cart) {
                // set modal with current item data
                if (engraving && engraving.trim() !== "") {
                    $('#engraving_checkbox').prop('checked', true).trigger('change');
                    $('#engraving_message').val(engraving).trigger('input');
                    engravingCountChar(document.getElementById('engraving_message'));
                }

                if (giftWrap === true || giftWrap === "true") {
                    $('#gift_wrapping_checkbox').prop('checked', true).trigger('change');

                    if (giftMessage && giftMessage.trim() !== "") {
                        $('#gift_message').val(giftMessage).trigger('input');
                        $('#no_card').prop('checked', false).trigger('change');
                        $('#include_card').prop('checked', true).trigger('change');
                    } else {
                        $('#include_card').prop('checked', false).trigger('change');
                        $('#no_card').prop('checked', true).trigger('change');
                    }
                } else {
                    $('#gift_wrapping_checkbox').prop('checked', false).trigger('change');
                    $('#no_card').prop('checked', false).trigger('change');
                    $('#include_card').prop('checked', true).trigger('change');
                }

                // datas for add/update
                if (variantId) {
                    $('#egm_btn').attr('data-variant-id', variantId);
                }

                if (itemKey) {
                    $('#egm_btn').attr('data-item-key', itemKey);
                }

                if (quantity) {
                    $('#egm_btn').attr('data-quantity', quantity);
                }

                $('#egm_btn').text(ojT('updateCart', 'Update cart'));

                // Hide engraving for small variants or products with no_engraving tag
                if(small || noEngraving === true || noEngraving === "true") {
                    $('#engravingGiftingModal .engraving-wrapper').hide();
                    $('#engravingGiftingModal .engraving-item').hide();
                } else {
                    $('#engravingGiftingModal .engraving-wrapper').show();
                    $('#engravingGiftingModal .engraving-item').show();
                }
            }
        };


        self.addCartPageItemListeners = function () {
            //self.addCartPageItemQuantitySelectorTogglerListener();
            //self.addCartPageItemQuantitySelectorListener();
            self.addCartPageItemQuantityIncreaseListener();
            self.addCartPageItemQuantityDecreaseListener();
            self.addCartPageItemRemoveListener();
            

            $('.add-engraving-opener').on('click', function (event) {
                event.preventDefault();
                if(window.new_design_enabled_on_cart_popup) {
                    self.cartPageEGMOpen($(this));
                } else {
                    $(this.parentNode).removeClass('open');                
                    $(this.parentNode).addClass('open');             
                }
                
                return false;
            });

            $('.add-engraving-edit').on('click', function (event) {
                event.preventDefault();
                $(this.parentNode).removeClass('open');                
                $(this.parentNode).addClass('open');                
                return false;
            });

            $('.add-engraving-cancel').on('click', function (event) {
                event.preventDefault();
                $(this.parentNode.parentNode.parentNode).removeClass('open');                
                return false;
            });

            $('.see-how-it-works').on('click', function (event) {
                event.preventDefault();
                $(this.parentNode).find('.see-how-it-works-lightbox').removeClass('open');                
                $(this.parentNode).find('.see-how-it-works-lightbox').addClass('open');                
                return false;
            });

            $('.see-how-it-works-lightbox').on('click', function (event) {
                event.preventDefault();
                $(this).removeClass('open');                
                return false;
            });

            $('.cart-page-item-list ul li .cart-page-item .add-engraving-wraper .add-engraving-body textarea').on('keyup', function (event) {
                let value = $(this).val();
                if(value.length > window.engraving_character_limit) {                    
                    this.value = value.slice(0, window.engraving_character_limit);
                    alert(ojT('engravingTooLong', 'Engraving cannot be more then [n] characters!').replace('[n]', window.engraving_character_limit));
                    return false;
                }
                let original_value = $(this).data().original;
                let length = value.length;
                let remaining_characters = Math.max(0, window.engraving_character_limit - length);
                $(this.parentNode).find('p.v4').html(ojCharsLeft(remaining_characters));
                if(original_value == value || value.length == 0) {
                    $(this.parentNode).find('.save-engraving-btn').removeClass('active');
                } else {
                    $(this.parentNode).find('.save-engraving-btn').removeClass('active');
                    $(this.parentNode).find('.save-engraving-btn').addClass('active');
                }
            });

            $('.save-engraving-btn').on('click', function (event) {
                event.preventDefault();

                let value = $(this.parentNode).find('textarea').val();
                let quantity = parseInt($(this.parentNode.parentNode.parentNode).find('.cart-page-item-quantity-selector p').html());                
                let line_item_key = $(this).data().lineItemKey;
                let line_item_properties_arr = $(this).data().itemProperties;
                if(typeof line_item_properties_arr != 'object') {
                    line_item_properties_arr = JSON.parse(unescape(line_item_properties_arr));
                }
                let line_item_properties = {};
                for(i in line_item_properties_arr) {
                    line_item_properties[line_item_properties_arr[i][0]] = line_item_properties_arr[i][1];
                }
                line_item_properties.engraving = value;
                var _this = this;
                self.startEngravingMessageUpdateLoadingState(_this.parentNode);
                self.updateLineItemPropertyInCart(line_item_key, quantity, JSON.stringify(line_item_properties), function (cart) {
                    self.updateSelfCart(cart);
                    var engraving_product_in_cart = 0;
                    var counter = 0;
                    for(i in self.cart.items) {
                        let item = self.cart.items[i];
                        if(item.product_id == window.engraving_product.id) {
                            engraving_product_in_cart += item.quantity;
                        }
                        if(item.properties && item.properties.engraving && item.properties.engraving.length) {
                            counter += item.quantity;
                        }
                    }
                    if(counter != engraving_product_in_cart) {
                        console.log('ERROR');
                    }
                    //console.log('counter');
                    //console.log(counter);
                    //console.log('engraving_product_in_cart');
                    //console.log(engraving_product_in_cart);

                    let ajax_endpoint = '/cart/add.json';
                    if(engraving_product_in_cart > 0) {
                        ajax_endpoint = '/cart/change.json';
                    }
                    if (window.engraving_product) {
                        $.post(ajax_endpoint, {id: window.engraving_product.variants[0].id, quantity: counter}, function (product) {
                            $(_this.parentNode).find('.save-engraving-btn').removeClass('active');
                            self.updateEngravingButtonText(_this, value);
                            self.updateCartPage(function () {
                                self.stopEngravingMessageUpdateLoadingState(_this.parentNode);
                            });
                        });
                    } else {
                        self.updateCartPage(function () {
                            self.stopEngravingMessageUpdateLoadingState(_this.parentNode);
                        });
                    }
                });

                return false;
            });

            $('.add-engraving-remover').on('click', function (event) {
                event.preventDefault();

                var save_btn = $(this.parentNode).find('.save-engraving-btn');
                if(!save_btn.length) {
                    alert('ERROR');
                    return false;
                }
                save_btn = save_btn[0];
                let value = null;
                let quantity = parseInt($(save_btn.parentNode.parentNode.parentNode).find('.cart-page-item-quantity-selector p').html());
                let line_item_key = $(save_btn).data().lineItemKey;
                let line_item_properties_arr = $(save_btn).data().itemProperties;
                if(typeof line_item_properties_arr != 'object') {
                    line_item_properties_arr = JSON.parse(unescape(line_item_properties_arr));
                }
                let line_item_properties = {};
                for(i in line_item_properties_arr) {
                    line_item_properties[line_item_properties_arr[i][0]] = line_item_properties_arr[i][1];
                }
                line_item_properties.engraving = value;
                self.startEngravingMessageUpdateLoadingState(save_btn.parentNode);
                self.updateLineItemPropertyInCart(line_item_key, quantity, JSON.stringify(line_item_properties), function (cart) {
                    self.updateSelfCart(cart);
                    var engraving_product_in_cart = 0;
                    var counter = 0;
                    for(i in self.cart.items) {
                        let item = self.cart.items[i];
                        if(item.product_id == window.engraving_product.id) {
                            engraving_product_in_cart += item.quantity;
                        }
                        if(item.properties && item.properties.engraving && item.properties.engraving.length) {
                            counter += item.quantity;
                        }
                    }
                    if(counter != engraving_product_in_cart) {
                        console.log('ERROR');
                    }
                    //console.log('counter');
                    //console.log(counter);
                    //console.log('engraving_product_in_cart');
                    //console.log(engraving_product_in_cart);

                    if (window.engraving_product) {
                        if(engraving_product_in_cart > 0) {
                            $.post('/cart/change.json', {id: window.engraving_product.variants[0].id, quantity: counter}, function (product) {
                                $(save_btn.parentNode).find('.save-engraving-btn').removeClass('active');
                                self.updateEngravingButtonText(save_btn, value);
                                self.updateCartPage(function () {
                                    self.stopEngravingMessageUpdateLoadingState(save_btn.parentNode);
                                });
                            });
                        } else {
                            $.post('/cart/add.json', {id: window.engraving_product.variants[0].id, quantity: counter}, function (product) {
                                $(save_btn.parentNode).find('.save-engraving-btn').removeClass('active');
                                self.updateEngravingButtonText(save_btn, value);
                                self.updateCartPage(function () {
                                    self.stopEngravingMessageUpdateLoadingState(save_btn.parentNode);
                                });
                            });
                        }
                    } else {
                        self.updateCartPage(function () {
                            self.stopEngravingMessageUpdateLoadingState(save_btn.parentNode);
                        });
                    }
                });

                return false;
            });
        };

        self.addCompareAtPrice = function (cart, callback) {
            var counter = 0;
            var cart = cart;       
            if(cart.items.length) {
                cart.items.forEach(function(item) {
                    $.ajax({ 
                        url: '/products/' + item.handle + '.js', 
                        dataType: 'json',
                        async: false, 
                        success: function(product) { 
                            product.variants.forEach(function(variant) {
                                if (variant.compare_at_price != null && variant.id == item.variant_id) {
                                    item.compare_at_price = variant.compare_at_price;
                                }
                            });
                            if(!item.compare_at_price) {
                                item.compare_at_price = 0;
                            }
                            counter++;
                            if(counter == cart.items.length) {
                                if(typeof callback == 'function') {
                                    callback();
                                }
                            }
                        } 
                    });
                });
            } else {
                if(typeof callback == 'function') {
                    callback();
                }
            }
            
            return cart;
        };

        self.updateLineItemPropertyInCart = function (key, quantity, properties, callback) {
            $.ajax({
                url: "/cart/change.js",
                type: "POST",
                data: '{"id":"' + key + '", "quantity": ' + quantity + ', "properties":' + properties + ' }', 
                contentType: "application/json",
                dataType: 'json'
            }).done(function (cart) {
                if(typeof callback == 'function') {
                    callback(cart);
                }
            });

        };

        self.updateEngravingButtonText = function (elem, value) {
            if(value && value.length > 0) {
                $(elem.parentNode.parentNode).find('.add-engraving-opener').hide();
                $(elem.parentNode.parentNode).find('.add-engraving-edit').show();
            } else {
                $(elem.parentNode.parentNode).find('.add-engraving-opener').show();
                $(elem.parentNode.parentNode).find('.add-engraving-edit').hide();
            }
        };

        self.addCartPopupItemListeners = function () {
            //self.addCartPopupItemQuantitySelectorTogglerListener();
            //self.addCartPopupItemQuantitySelectorListener();
            self.addCartPageItemQuantityIncreaseListener();
            self.addCartPageItemQuantityDecreaseListener();
            self.addCartPopupItemRemoveListener();
        };

        self.updateSelfCart = function (cart, callback) {
            if(cart) {
                self.cart = cart;
            } else {
                $.getJSON(ojCartRoot() + 'cart', function (cart) {
                    self.cart = cart;
                    if(typeof callback == 'function') {
                        callback();
                    }
                });
            }
        };

        /* A quantity above the stock left: Shopify keeps what is left and answers 422 from
           cart/update.js. The quantity handlers above have no error callback, so the loaders
           stayed over the page. Render the bag again and show Shopify's message above the lines.
           US members sale lines are told on the line by assets/oj-members-sale-bag.js. */
        self.showQuantityError = function (scope, message) {
            let box = $(scope);
            if (!box.length || !message) {
                return;
            }
            box.find('.cart-quantity-error').remove();
            let note = $('<p class="cart-quantity-error" role="status" style="margin: 0 0 12px; color: #e04e39; font-size: 12px; line-height: 16px;"></p>').text(message);
            let list = box.find('ul').first();
            if (list.length) {
                note.insertBefore(list);
            } else {
                box.prepend(note);
            }
            setTimeout(function () { note.remove(); }, 8000);
        };

        self.addQuantityErrorListener = function () {
            $(document).on('ajaxError', function (event, xhr, settings) {
                if (!xhr || xhr.status !== 422 || !settings || !/\/cart\/update\.js/.test(String(settings.url))) {
                    return;
                }
                if (window.ojMembersSale && typeof window.ojMembersSale.ownsUpdate === 'function' && window.ojMembersSale.ownsUpdate(settings)) {
                    return;
                }
                let message = '';
                try {
                    message = (JSON.parse(xhr.responseText) || {}).description || '';
                } catch (err) {
                    message = '';
                }
                self.updateCartPopup(function () {
                    self.showQuantityError('.cart-popup-content', message);
                });
                if ($('.cart-page-item-list').length) {
                    self.updateCartPage(function () {
                        self.showQuantityError('.cart-page-item-list', message);
                    });
                }
            });
        };

        self.init = function () {
            self.updateSelfCart(null, self.addListeners);
            self.addQuantityErrorListener();
        };

        return self;
    };

    ready(function () {
      window.cart_popup = CartPopup();
      window.cart_popup.init();
    });
